/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"vjs","1":"hammer"}[chunkId]||chunkId) + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 232);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(23);
var hide = __webpack_require__(10);
var redefine = __webpack_require__(19);
var ctx = __webpack_require__(14);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(1);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(71)('wks');
var uid = __webpack_require__(28);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(20);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(85);
var toPrimitive = __webpack_require__(43);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(4)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var createDesc = __webpack_require__(27);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(23);
var fails = __webpack_require__(4);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(64);
var defined = __webpack_require__(24);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(24);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(22);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(42);
var createDesc = __webpack_require__(27);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(43);
var has = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(85);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(8)) {
  var LIBRARY = __webpack_require__(25);
  var global = __webpack_require__(3);
  var fails = __webpack_require__(4);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(74);
  var $buffer = __webpack_require__(105);
  var ctx = __webpack_require__(14);
  var anInstance = __webpack_require__(30);
  var propertyDesc = __webpack_require__(27);
  var hide = __webpack_require__(10);
  var redefineAll = __webpack_require__(34);
  var toInteger = __webpack_require__(20);
  var toLength = __webpack_require__(6);
  var toIndex = __webpack_require__(104);
  var toAbsoluteIndex = __webpack_require__(36);
  var toPrimitive = __webpack_require__(43);
  var has = __webpack_require__(9);
  var classof = __webpack_require__(44);
  var isObject = __webpack_require__(1);
  var toObject = __webpack_require__(13);
  var isArrayIter = __webpack_require__(65);
  var create = __webpack_require__(40);
  var getPrototypeOf = __webpack_require__(33);
  var gOPN = __webpack_require__(41).f;
  var getIterFn = __webpack_require__(75);
  var uid = __webpack_require__(28);
  var wks = __webpack_require__(5);
  var createArrayMethod = __webpack_require__(39);
  var createArrayIncludes = __webpack_require__(59);
  var speciesConstructor = __webpack_require__(52);
  var ArrayIterators = __webpack_require__(54);
  var Iterators = __webpack_require__(32);
  var $iterDetect = __webpack_require__(48);
  var setSpecies = __webpack_require__(51);
  var arrayFill = __webpack_require__(58);
  var arrayCopyWithin = __webpack_require__(80);
  var $DP = __webpack_require__(7);
  var $GOPD = __webpack_require__(15);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitterMicro = function () {
  function EventEmitterMicro() {
    _classCallCheck(this, EventEmitterMicro);

    this._events = {};
  }

  _createClass(EventEmitterMicro, [{
    key: "on",
    value: function on(type, listener) {
      this._events[type] = this._events[type] || [];
      this._events[type].unshift(listener);
    }
  }, {
    key: "once",
    value: function once(type, listener) {
      var _this = this;

      var wrapped = function wrapped(data) {
        _this.off(type, wrapped);
        if (data !== undefined) {
          listener(data);
        } else {
          listener();
        }
      };
      this.on(type, wrapped);
    }
  }, {
    key: "off",
    value: function off(type, listener) {
      if (!this.has(type)) {
        return;
      }
      var index = this._events[type].indexOf(listener);
      if (index === -1) {
        return;
      }
      this._events[type].splice(index, 1);
    }
  }, {
    key: "trigger",
    value: function trigger(type, data) {
      if (!this.has(type)) {
        return;
      }
      for (var i = this._events[type].length - 1; i >= 0; i--) {
        if (data !== undefined) {
          this._events[type][i](data);
        } else {
          this._events[type][i]();
        }
      }
    }
  }, {
    key: "has",
    value: function has(type) {
      if (type in this._events === false || this._events[type].length === 0) {
        return false;
      }
      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var type in this._events) {
        this._events[type] = null;
      }
      this._events = null;
    }
  }]);

  return EventEmitterMicro;
}();

exports.default = EventEmitterMicro;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(28)('meta');
var isObject = __webpack_require__(1);
var has = __webpack_require__(9);
var setDesc = __webpack_require__(7).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(4)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(10);
var has = __webpack_require__(9);
var SRC = __webpack_require__(28)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(23).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewportEmitter = function (_EventEmitterMicro) {
  _inherits(ViewportEmitter, _EventEmitterMicro);

  function ViewportEmitter() {
    _classCallCheck(this, ViewportEmitter);

    var _this = _possibleConstructorReturn(this, (ViewportEmitter.__proto__ || Object.getPrototypeOf(ViewportEmitter)).call(this));

    _this.breakpoint = '';

    _this.scrollY(true);
    _this.clientHeight(true);

    _this._onScroll = _this._onScroll.bind(_this);
    _this._onResizeImmediate = _this._onResizeImmediate.bind(_this);
    _this._onOrientationChange = _this._onOrientationChange.bind(_this);
    _this._onBreakpointChange = _this._onBreakpointChange.bind(_this);

    window.addEventListener('scroll', _this._onScroll);
    window.addEventListener('resize', _this._onResizeImmediate);
    window.addEventListener('orientationchange', _this._onOrientationChange);

    // When everything in DOM is ready, we trigger a resize event to update positioning
    document.addEventListener('DOMContentLoaded', function () {
      window.dispatchEvent(new window.CustomEvent('resize'));
    });

    /*
    if (document.fonts) {
      document.fonts.ready.then(function () {
        window.dispatchEvent(new window.CustomEvent('resize'))
      })
    }
    */
    return _this;
  }

  _createClass(ViewportEmitter, [{
    key: '_onScroll',
    value: function _onScroll(event) {
      this.scrollY(true);
      this.trigger('scroll', event);
    }
  }, {
    key: '_onResizeImmediate',
    value: function _onResizeImmediate(event) {
      this.scrollY(true);
      this.clientHeight(true);
      this.trigger('resize', event);
    }
  }, {
    key: '_onOrientationChange',
    value: function _onOrientationChange(event) {
      this.trigger('orientationchange', event);
    }
  }, {
    key: '_onBreakpointChange',
    value: function _onBreakpointChange() {
      var from = this.breakpoint;
      this.breakpoint = this._defaultBreakpoint;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._breakpoints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var key = _ref2[0];
          var list = _ref2[1];

          if (list.matches) {
            this.breakpoint = key;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (from !== this.breakpoint) {
        this.trigger('breakpoint', {
          from: from,
          to: this.breakpoint
        });
      }
    }
  }, {
    key: 'scrollY',
    value: function scrollY(update) {
      if (update) {
        var doc = document.documentElement;
        this.cachedScrollY = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      }
      return this.cachedScrollY;
    }
  }, {
    key: 'clientHeight',
    value: function clientHeight(update) {
      if (update) {
        this.cachedClientHeight = document.documentElement.clientHeight || window.innerHeight;
      }
      return this.cachedClientHeight;
    }
  }, {
    key: 'setBreakpoints',
    value: function setBreakpoints(defaultBreakpoint, breakpoints) {
      this.breakpoint = defaultBreakpoint;
      this._defaultBreakpoint = defaultBreakpoint;
      // remove old breakpoint listeners
      if (this._breakpoints) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this._breakpoints[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref3 = _step2.value;

            var _ref4 = _slicedToArray(_ref3, 2);

            var list = _ref4[1];

            list.removeListener(this._onMatchMediaChange);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this._breakpoints = [];
      // Set up media query listeners
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = breakpoints[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref5 = _step3.value;

          var _ref6 = _slicedToArray(_ref5, 2);

          var key = _ref6[0];
          var value = _ref6[1];

          var _list = window.matchMedia(value);
          this._breakpoints.unshift([key, _list]);
          if (_list.matches) {
            this.breakpoint = key;
          }
          _list.addListener(this._onBreakpointChange);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.trigger('breakpoint', {
        from: '',
        to: this.breakpoint
      });
    }
  }, {
    key: 'getBreakpoints',
    value: function getBreakpoints() {
      return [this._defaultBreakpoint].concat(this._breakpoints.map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 1),
            key = _ref8[0];

        return key;
      }));
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResizeImmediate);
      window.removeEventListener('orientationchange', this._onOrientationChange);
    }
  }]);

  return ViewportEmitter;
}(_eventEmitterMicro2.default);

var viewportEmitter = new ViewportEmitter();

exports.default = viewportEmitter;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(97);
var enumBugKeys = __webpack_require__(62);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(5)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(9);
var toObject = __webpack_require__(13);
var IE_PROTO = __webpack_require__(70)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(19);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(7).f;
var has = __webpack_require__(9);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(20);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(1);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundingClientRect = getBoundingClientRect;
exports.getContentDimensions = getContentDimensions;
exports.getDimensions = getDimensions;
exports.getPagePosition = getPagePosition;
exports.getPercentInViewport = getPercentInViewport;
exports.getPixelsInViewport = getPixelsInViewport;
exports.getPosition = getPosition;
exports.getScrollX = getScrollX;
exports.getScrollY = getScrollY;
exports.getViewportPosition = getViewportPosition;
exports.isInViewport = isInViewport;
exports.getAddressBarHeight = getAddressBarHeight;
// TODO: Add proper names to arguments

function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    width: rect.width || rect.right - rect.left,
    height: rect.height || rect.bottom - rect.top
  };
}

function getContentDimensions(element, a) {
  var scale = 1;
  if (a) {
    scale = getBoundingClientRect(element).width / element.offsetWidth;
  }
  return {
    width: element.scrollWidth * scale,
    height: element.scrollHeight * scale
  };
}

function getDimensions(element, a) {
  if (a) {
    var rect = getBoundingClientRect(element);
    return {
      width: rect.width,
      height: rect.height
    };
  }
  return {
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}

function getPagePosition(element, f) {
  if (f) {
    var _rect = getBoundingClientRect(element);
    var scrollX = getScrollX();
    var scrollY = getScrollY();
    return {
      top: _rect.top + scrollY,
      right: _rect.right + scrollX,
      bottom: _rect.bottom + scrollY,
      left: _rect.left + scrollX
    };
  }
  var dimensions = getDimensions(element, f);
  var rect = {
    top: element.offsetTop,
    left: element.offsetLeft,
    width: dimensions.width,
    height: dimensions.height
  };
  while (element = element.offsetParent) {
    rect.top += element.offsetTop;
    rect.left += element.offsetLeft;
  }
  return {
    top: rect.top,
    right: rect.left + rect.width,
    bottom: rect.top + rect.height,
    left: rect.left
  };
}

function getPercentInViewport(element, a) {
  var c = getPixelsInViewport(element, a);
  var d = getDimensions(element, a).height;
  return c / d;
}

function getPixelsInViewport(element, a) {
  var b = document.documentElement.clientHeight;
  var f = getViewportPosition(element, a);
  var c;
  if (f.top >= b || f.bottom <= 0) {
    return 0;
  }
  c = f.bottom - f.top;
  if (f.top < 0) {
    c += f.top;
  }
  if (f.bottom > b) {
    c -= f.bottom - b;
  }
  return c;
}

function getPosition(element, a) {
  var rect;
  if (a) {
    rect = getBoundingClientRect(element);
    if (element.offsetParent) {
      var parentRect = getBoundingClientRect(element.offsetParent);
      rect.top -= parentRect.top;
      rect.left -= parentRect.left;
    }
  } else {
    var dimensions = getDimensions(element, a);
    rect = {
      top: element.offsetTop,
      left: element.offsetLeft,
      width: dimensions.width,
      height: dimensions.height
    };
  }
  return {
    top: rect.top,
    right: rect.left + rect.width,
    bottom: rect.top + rect.height,
    left: rect.left
  };
}

function getScrollX(element) {
  element = element || window;
  if (element === window) {
    var pos = window.pageXOffset;
    if (!pos) {
      element = document.documentElement || document.body.parentNode || document.body;
    } else {
      return pos;
    }
  }
  return element.scrollLeft;
}

function getScrollY(element) {
  element = element || window;
  if (element === window) {
    var pos = window.pageYOffset;
    if (!pos) {
      element = document.documentElement || document.body.parentNode || document.body;
    } else {
      return pos;
    }
  }
  return element.scrollTop;
}

function getViewportPosition(element, f) {
  if (f) {
    var rect = getBoundingClientRect(element);
    return {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left
    };
  }
  var pagePosition = getPagePosition(element);
  var scrollX = getScrollX();
  var scrollY = getScrollY();
  return {
    top: pagePosition.top - scrollY,
    right: pagePosition.right - scrollX,
    bottom: pagePosition.bottom - scrollY,
    left: pagePosition.left - scrollX
  };
}

function isInViewport(element, a, d) {
  var c;
  d = d || 0;
  if (typeof d === 'string' && d.slice(-2) === 'px') {
    d = parseInt(d, 10);
    c = getPixelsInViewport(element, a);
  } else {
    c = getPercentInViewport(element, a);
  }
  return c > 0 && c >= d;
}

var addressBarHeight = null;
function getAddressBarHeight() {
  if (addressBarHeight === null) {
    var testEle = document.createElement('div');
    testEle.style = 'position:fixed;height:100%';
    document.body.appendChild(testEle);
    var viewportHeight = testEle.offsetHeight;
    testEle.style = 'position:fixed;height:100vh';
    var vhHeight = testEle.offsetHeight;
    document.body.removeChild(testEle);
    addressBarHeight = vhHeight - viewportHeight;
  }
  return addressBarHeight;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(14);
var IObject = __webpack_require__(64);
var toObject = __webpack_require__(13);
var toLength = __webpack_require__(6);
var asc = __webpack_require__(236);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(2);
var dPs = __webpack_require__(243);
var enumBugKeys = __webpack_require__(62);
var IE_PROTO = __webpack_require__(70)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(61)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(84).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(97);
var hiddenKeys = __webpack_require__(62).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(1);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(31);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(19);
var redefineAll = __webpack_require__(34);
var meta = __webpack_require__(18);
var forOf = __webpack_require__(47);
var anInstance = __webpack_require__(30);
var isObject = __webpack_require__(1);
var fails = __webpack_require__(4);
var $iterDetect = __webpack_require__(48);
var setToStringTag = __webpack_require__(35);
var inheritIfRequired = __webpack_require__(239);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(247);
var redefine = __webpack_require__(19);
var hide = __webpack_require__(10);
var fails = __webpack_require__(4);
var defined = __webpack_require__(24);
var wks = __webpack_require__(5);
var regexpExec = __webpack_require__(68);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var call = __webpack_require__(90);
var isArrayIter = __webpack_require__(65);
var anObject = __webpack_require__(2);
var toLength = __webpack_require__(6);
var getIterFn = __webpack_require__(75);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(44);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(8);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(22);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(29);
var step = __webpack_require__(92);
var Iterators = __webpack_require__(32);
var toIObject = __webpack_require__(12);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(91)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.extend = extend;
exports.clone = clone;
exports.defaults = defaults;
var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
  var objects;
  if (arguments.length < 2) {
    objects = [{}, arguments[0]];
  } else {
    objects = [].slice.call(arguments);
  }
  var result = objects.shift();
  objects.forEach(function (obj) {
    if (obj != null) {
      for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          result[key] = obj[key];
        }
      }
    }
  });
  return result;
}

function _deepclone(obj1, obj2) {
  for (var key in obj2) {
    if (hasOwnProperty.call(obj2, key)) {
      if (obj2[key] === null) {
        obj1[key] = null;
      } else {
        if (_typeof(obj2[key]) === 'object') {
          obj1[key] = Array.isArray(obj2[key]) ? [] : {};
          _deepclone(obj1[key], obj2[key]);
        } else {
          obj1[key] = obj2[key];
        }
      }
    }
  }
  return obj1;
}

function clone(obj, deepClone) {
  if (deepClone) {
    return _deepclone({}, obj);
  }
  return extend({}, obj);
}

function defaults(defaults) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if ((typeof defaults === 'undefined' ? 'undefined' : _typeof(defaults)) !== 'object') {
    throw new TypeError('defaults: must provide a defaults object');
  }
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
    throw new TypeError('defaults: options must be a typeof object');
  }
  return extend({}, defaults, options);
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(101)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(36);
var toLength = __webpack_require__(6);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(12);
var toLength = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(36);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(7);
var createDesc = __webpack_require__(27);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(1);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(5)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(32);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(83);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(1);
var anObject = __webpack_require__(2);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(14)(Function.call, __webpack_require__(15).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(71)('keys');
var uid = __webpack_require__(28);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(23);
var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(25) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(89);
var defined = __webpack_require__(24);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var invoke = __webpack_require__(86);
var html = __webpack_require__(84);
var cel = __webpack_require__(61);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(31)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(10);
var uid = __webpack_require__(28);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(44);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(32);
module.exports = __webpack_require__(23).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.page = exports.sideMenu = undefined;

var _page = __webpack_require__(230);

var _page2 = _interopRequireDefault(_page);

var _fastclick = __webpack_require__(248);

var _fastclick2 = _interopRequireDefault(_fastclick);

var _navigation = __webpack_require__(233);

var _form = __webpack_require__(216);

var _form2 = _interopRequireDefault(_form);

var _datePickerForm = __webpack_require__(218);

var _datePickerForm2 = _interopRequireDefault(_datePickerForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Set up FastClick
document.addEventListener('DOMContentLoaded', function () {
  _fastclick2.default.attach(document.body);
});

// Set up side menu
var sideMenu = null;
var sidemenuContainer = document.getElementById('side-panel');
if (sidemenuContainer) {
  exports.sideMenu = sideMenu = new _navigation.SideMenu(sidemenuContainer, document.getElementById('page'));
  var toggleButtons = document.querySelectorAll('a[href="#side-panel"]');
  for (var i = 0; i < toggleButtons.length; i++) {
    sideMenu.addToggler(toggleButtons[i]);
  }
}

// Set up date picker forms
window.addEventListener('cmt-form-initialized', function (event) {
  if (event.detail.form.element.classList.contains('cmt-date-picker-form')) {
    event.detail.form.datePicker = new _datePickerForm2.default(event.detail.form);
  }
});

// Set up forms
var forms = [];
var formElements = document.querySelectorAll('form.cmt-form');
for (var _i = 0; _i < formElements.length; _i++) {
  var formElement = formElements[_i];
  forms.push(new _form2.default(formElement));
}

// Set up page
var page = new _page2.default();

// Export
exports.sideMenu = sideMenu;
exports.page = page;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _viewportEmitter = __webpack_require__(21);

var _viewportEmitter2 = _interopRequireDefault(_viewportEmitter);

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

var _domNodes = __webpack_require__(226);

var _domMetrics = __webpack_require__(38);

var _object = __webpack_require__(56);

var _array = __webpack_require__(224);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultOptions = {
  autoStart: false
};

var TrackedElement = function (_EventEmitterMicro) {
  _inherits(TrackedElement, _EventEmitterMicro);

  function TrackedElement(element) {
    _classCallCheck(this, TrackedElement);

    if (!(0, _domNodes.isElement)(element)) {
      throw new TypeError('TrackedElement: ' + element + ' is not a valid DOM element');
    }

    var _this = _possibleConstructorReturn(this, (TrackedElement.__proto__ || Object.getPrototypeOf(TrackedElement)).call(this));

    _this.element = element;
    _this.inView = false;
    _this.percentInView = 0;
    _this.pixelsInView = 0;
    _this.offsetTop = 0;
    _this.top = 0;
    _this.right = 0;
    _this.bottom = 0;
    _this.left = 0;
    _this.width = 0;
    _this.height = 0;
    return _this;
  }

  _createClass(TrackedElement, [{
    key: 'destroy',
    value: function destroy() {
      this.element = null;
      _get(TrackedElement.prototype.__proto__ || Object.getPrototypeOf(TrackedElement.prototype), 'destroy', this).call(this);
    }
  }]);

  return TrackedElement;
}(_eventEmitterMicro2.default);

var ElementTracker = function (_EventEmitterMicro2) {
  _inherits(ElementTracker, _EventEmitterMicro2);

  function ElementTracker(element, options) {
    _classCallCheck(this, ElementTracker);

    var _this2 = _possibleConstructorReturn(this, (ElementTracker.__proto__ || Object.getPrototypeOf(ElementTracker)).call(this));

    _this2.options = (0, _object.clone)(defaultOptions);
    _this2.options = (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object' ? (0, _object.extend)(_this2.options, options) : _this2.options;
    _this2._scrollY = _viewportEmitter2.default.scrollY();
    _this2._windowHeight = _viewportEmitter2.default.clientHeight();
    _this2.tracking = false;
    _this2.elements = [];
    if (element && (Array.isArray(element) || (0, _domNodes.isNodeList)(element) || (0, _domNodes.isElement)(element))) {
      _this2.addElements(element);
    }
    _this2.refreshAllElementStates = _this2.refreshAllElementStates.bind(_this2);
    _this2.refreshAllElementMetrics = _this2.refreshAllElementMetrics.bind(_this2);
    if (_this2.options.autoStart) {
      _this2.start();
    }
    return _this2;
  }

  _createClass(ElementTracker, [{
    key: 'destroy',
    value: function destroy() {
      this.stop();
      for (var i = 0, len = this.elements.length; i < len; i++) {
        this.elements[i].destroy();
      }
      this.elements = null;
      this.options = null;
    }
  }, {
    key: '_registerElements',
    value: function _registerElements(elements) {
      var _this3 = this;

      elements = [].concat(elements);
      elements.forEach(function (element) {
        if (_this3._elementInDOM(element)) {
          var trackedElement = new TrackedElement(element);
          trackedElement.offsetTop = trackedElement.element.offsetTop;
          _this3.elements.push(trackedElement);
        }
      });
    }
  }, {
    key: '_registerTrackedElements',
    value: function _registerTrackedElements(trackedElements) {
      var _this4 = this;

      [].concat(trackedElements).forEach(function (trackedElement) {
        if (_this4._elementInDOM(trackedElement.element)) {
          trackedElement.offsetTop = trackedElement.element.offsetTop;
          _this4.elements.push(trackedElement);
        }
      });
    }
  }, {
    key: '_elementInDOM',
    value: function _elementInDOM(element) {
      var body = document.getElementsByTagName('body')[0];
      return (0, _domNodes.isElement)(element) && body.contains(element);
    }
  }, {
    key: '_elementPercentInView',
    value: function _elementPercentInView(trackedElement) {
      return trackedElement.pixelsInView / trackedElement.height;
    }
  }, {
    key: '_elementPixelsInView',
    value: function _elementPixelsInView(trackedElement) {
      var a = trackedElement.top - this._scrollY;
      var b = trackedElement.bottom - this._scrollY;
      if (a > this._windowHeight || b < 0) {
        return 0;
      }
      return Math.min(b, this._windowHeight) - Math.max(a, 0);
    }
  }, {
    key: '_ifInView',
    value: function _ifInView(trackedElement, alreadyInView) {
      if (!alreadyInView) {
        trackedElement.trigger('enterview', trackedElement);
      }
    }
  }, {
    key: '_ifAlreadyInView',
    value: function _ifAlreadyInView(trackedElement) {
      if (!trackedElement.inView) {
        trackedElement.trigger('exitview', trackedElement);
      }
    }
  }, {
    key: 'addElements',
    value: function addElements(elements) {
      elements = (0, _domNodes.isNodeList)(elements) ? (0, _array.toArray)(elements) : [].concat(elements);
      elements.forEach(this.addElement, this);
    }
  }, {
    key: 'addElement',
    value: function addElement(element) {
      var trackedElement = null;
      if ((0, _domNodes.isElement)(element)) {
        trackedElement = new TrackedElement(element);
        this._registerTrackedElements(trackedElement);
        this.refreshElementMetrics(trackedElement);
        this.refreshElementState(trackedElement);
      } else {
        throw new TypeError('ElementTracker: ' + element + ' is not a valid DOM element');
      }
      return trackedElement;
    }
  }, {
    key: 'removeElement',
    value: function removeElement(element) {
      this.elements = this.elements.filter(function (trackedElement) {
        return !(trackedElement === element || trackedElement.element === element);
      });
    }
  }, {
    key: 'start',
    value: function start() {
      if (this.tracking === false) {
        this.tracking = true;
        _viewportEmitter2.default.on('resize', this.refreshAllElementMetrics);
        _viewportEmitter2.default.on('orientationchange', this.refreshAllElementMetrics);
        _viewportEmitter2.default.on('scroll', this.refreshAllElementStates);
        this.refreshAllElementMetrics();
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.tracking === true) {
        this.tracking = false;
        _viewportEmitter2.default.off('resize', this.refreshAllElementMetrics);
        _viewportEmitter2.default.off('orientationchange', this.refreshAllElementMetrics);
        _viewportEmitter2.default.off('scroll', this.refreshAllElementStates);
      }
    }
  }, {
    key: 'refreshAllElementMetrics',
    value: function refreshAllElementMetrics() {
      this._scrollY = _viewportEmitter2.default.scrollY();
      this._windowHeight = _viewportEmitter2.default.clientHeight();
      this.elements.forEach(this.refreshElementMetrics, this);
    }
  }, {
    key: 'refreshElementMetrics',
    value: function refreshElementMetrics(trackedElement) {
      var dimensions = (0, _domMetrics.getDimensions)(trackedElement.element);
      var position = (0, _domMetrics.getPagePosition)(trackedElement.element);
      trackedElement = (0, _object.extend)(trackedElement, dimensions, position);
      return this.refreshElementState(trackedElement);
    }
  }, {
    key: 'refreshAllElementStates',
    value: function refreshAllElementStates() {
      this._scrollY = _viewportEmitter2.default.scrollY();
      this.elements.forEach(this.refreshElementState, this);
    }
  }, {
    key: 'refreshElementState',
    value: function refreshElementState(trackedElement) {
      var alreadyInView = trackedElement.inView;
      trackedElement.pixelsInView = this._elementPixelsInView(trackedElement);
      trackedElement.percentInView = this._elementPercentInView(trackedElement);
      trackedElement.inView = trackedElement.pixelsInView > 0;
      if (trackedElement.inView) {
        this._ifInView(trackedElement, alreadyInView);
      }
      if (alreadyInView) {
        this._ifAlreadyInView(trackedElement);
      }
      return trackedElement;
    }
  }]);

  return ElementTracker;
}(_eventEmitterMicro2.default);

exports.default = ElementTracker;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTo;

var _domMetrics = __webpack_require__(38);

var _easings = __webpack_require__(227);

function scrollTo() {
  var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // because it's so fucking difficult to detect the scrolling element, just move them all
  function move(amount) {
    document.documentElement.scrollTop = amount;
    document.body.parentNode.scrollTop = amount;
    document.body.scrollTop = amount;
  }
  var start = (0, _domMetrics.getScrollY)();
  var change = to - start;
  var currentTime = 0;
  var increment = 20;
  var animateScroll = function animateScroll() {
    currentTime += increment;
    var val = (0, _easings.easeInOutQuad)(Math.min(currentTime, duration), start, change, duration);
    move(val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      if (callback && typeof callback === 'function') {
        callback();
      }
    }
  };
  animateScroll();
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElementScrollMotionEmitter = exports.ScrollMotionEmitter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _viewportEmitter = __webpack_require__(21);

var _viewportEmitter2 = _interopRequireDefault(_viewportEmitter);

var _motionEmitter = __webpack_require__(229);

var _motionEmitter2 = _interopRequireDefault(_motionEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import ResizeObserver from 'resize-observer-polyfill'

var ScrollMotionEmitter = exports.ScrollMotionEmitter = function (_MotionEmitter) {
  _inherits(ScrollMotionEmitter, _MotionEmitter);

  function ScrollMotionEmitter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ScrollMotionEmitter);

    var _this = _possibleConstructorReturn(this, (ScrollMotionEmitter.__proto__ || Object.getPrototypeOf(ScrollMotionEmitter)).call(this, options));

    _this.smooth = _this.options.smooth || false;

    if (!_this.options.overrideScroll) {
      _this._bindScrollEvents();
    }
    return _this;
  }

  _createClass(ScrollMotionEmitter, [{
    key: 'updateValue',
    value: function updateValue(a) {
      if (this.smooth) {
        return _get(ScrollMotionEmitter.prototype.__proto__ || Object.getPrototypeOf(ScrollMotionEmitter.prototype), 'updateValue', this).call(this, a);
      }
      if (this._currentValue === this._targetValue) {
        this._shouldEmitChange = false;
        return;
      }
      this._currentValue = this._targetValue;
      this._shouldEmitChange = true;
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(scrollPosition) {
      if (typeof scrollPosition !== 'number') {
        scrollPosition = _viewportEmitter2.default.scrollY();
      }
      var progress;
      if (scrollPosition < this.min) {
        progress = this.min;
      } else {
        if (scrollPosition > this.max) {
          progress = this.max;
        } else {
          progress = scrollPosition;
        }
      }
      progress = (progress - this.min) / (this.max - this.min);
      this.setProgress(progress);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._boundHandleScroll) {
        _viewportEmitter2.default.off('scroll', this._boundHandleScroll);
      }
      return _get(ScrollMotionEmitter.prototype.__proto__ || Object.getPrototypeOf(ScrollMotionEmitter.prototype), 'destroy', this).call(this);
    }
  }, {
    key: '_bindScrollEvents',
    value: function _bindScrollEvents() {
      this._boundHandleScroll = this.handleScroll.bind(this);
      _viewportEmitter2.default.on('scroll', this._boundHandleScroll);
    }
  }]);

  return ScrollMotionEmitter;
}(_motionEmitter2.default);

var ElementScrollMotionEmitter = exports.ElementScrollMotionEmitter = function (_ScrollMotionEmitter) {
  _inherits(ElementScrollMotionEmitter, _ScrollMotionEmitter);

  function ElementScrollMotionEmitter(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ElementScrollMotionEmitter);

    var _this2 = _possibleConstructorReturn(this, (ElementScrollMotionEmitter.__proto__ || Object.getPrototypeOf(ElementScrollMotionEmitter)).call(this, options));

    if (!(element instanceof window.HTMLElement)) {
      return _possibleConstructorReturn(_this2);
    }
    _this2.el = element;
    _this2.options = options;
    if (_this2.options.offsetTop) {
      _this2.offsetTop = _this2.options.offsetTop;
    }
    if (_this2.options.offsetBottom) {
      _this2.offsetBottom = _this2.options.offsetBottom;
    }
    _this2.setEmitterBounds();
    if (!_this2.options.overrideResize) {
      _this2._bindResizeEvents();
    }
    return _this2;
  }

  _createClass(ElementScrollMotionEmitter, [{
    key: 'setEmitterBounds',
    value: function setEmitterBounds() {
      this._elementBounds = this.el.getBoundingClientRect();
      var scrollPosition = _viewportEmitter2.default.scrollY();
      var topScroll = this._elementBounds.top + scrollPosition;
      var bottomScroll = this._elementBounds.bottom + scrollPosition;
      var offsetTop = this.offsetTop || 0;
      var offsetBottom = this.offsetBottom || 0;
      if (typeof this.offsetTop === 'function') {
        offsetTop = this.offsetTop();
      }
      if (typeof this.offsetBottom === 'function') {
        offsetBottom = this.offsetBottom();
      }
      this.min = this.options.min = topScroll + offsetTop;
      this.max = this.options.max = bottomScroll + offsetBottom;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._boundHandleResize) {
        _viewportEmitter2.default.off('resize', this._boundHandleResize);
        _viewportEmitter2.default.off('orientationchange', this._boundHandleResize);
      }
      // this.ro.disconnect()
      _get(ElementScrollMotionEmitter.prototype.__proto__ || Object.getPrototypeOf(ElementScrollMotionEmitter.prototype), 'destroy', this).call(this);
    }
  }, {
    key: '_bindResizeEvents',
    value: function _bindResizeEvents() {
      this._boundHandleResize = this.handleResize.bind(this);
      _viewportEmitter2.default.on('resize', this._boundHandleResize);
      _viewportEmitter2.default.on('orientationchange', this._boundHandleResize);

      /*
      this.ro = new ResizeObserver((entries, observer) => {
        this._boundHandleResize()
      })
      this.ro.observe(this.el)
      */
    }
  }, {
    key: '_handleClockUpdate',
    value: function _handleClockUpdate(a) {
      if (this._shouldUpdateOnResize) {
        this.setEmitterBounds();
        this.handleScroll();
        this._shouldUpdateOnResize = false;
      }
      _get(ElementScrollMotionEmitter.prototype.__proto__ || Object.getPrototypeOf(ElementScrollMotionEmitter.prototype), '_handleClockUpdate', this).call(this, a);
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      this._shouldUpdateOnResize = true;
      this.handleScroll();
    }
  }]);

  return ElementScrollMotionEmitter;
}(ScrollMotionEmitter);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(36);
var toLength = __webpack_require__(6);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(7).f;
var create = __webpack_require__(40);
var redefineAll = __webpack_require__(34);
var ctx = __webpack_require__(14);
var anInstance = __webpack_require__(30);
var forOf = __webpack_require__(47);
var $iterDefine = __webpack_require__(91);
var step = __webpack_require__(92);
var setSpecies = __webpack_require__(51);
var DESCRIPTORS = __webpack_require__(8);
var fastKey = __webpack_require__(18).fastKey;
var validate = __webpack_require__(37);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(34);
var getWeak = __webpack_require__(18).getWeak;
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(1);
var anInstance = __webpack_require__(30);
var forOf = __webpack_require__(47);
var createArrayMethod = __webpack_require__(39);
var $has = __webpack_require__(9);
var validate = __webpack_require__(37);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(4)(function () {
  return Object.defineProperty(__webpack_require__(61)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(31);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(1);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(1);
var cof = __webpack_require__(31);
var MATCH = __webpack_require__(5)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(25);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(19);
var hide = __webpack_require__(10);
var Iterators = __webpack_require__(32);
var $iterCreate = __webpack_require__(240);
var setToStringTag = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(33);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(22);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(26);
var gOPS = __webpack_require__(49);
var pIE = __webpack_require__(42);
var toObject = __webpack_require__(13);
var IObject = __webpack_require__(64);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(4)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(12);
var gOPN = __webpack_require__(41).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(9);
var toIObject = __webpack_require__(12);
var arrayIndexOf = __webpack_require__(59)(false);
var IE_PROTO = __webpack_require__(70)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(26);
var toIObject = __webpack_require__(12);
var isEnum = __webpack_require__(42).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(41);
var gOPS = __webpack_require__(49);
var anObject = __webpack_require__(2);
var Reflect = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(20);
var defined = __webpack_require__(24);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(6);
var repeat = __webpack_require__(103);
var defined = __webpack_require__(24);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(20);
var defined = __webpack_require__(24);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(20);
var toLength = __webpack_require__(6);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(8);
var LIBRARY = __webpack_require__(25);
var $typed = __webpack_require__(74);
var hide = __webpack_require__(10);
var redefineAll = __webpack_require__(34);
var fails = __webpack_require__(4);
var anInstance = __webpack_require__(30);
var toInteger = __webpack_require__(20);
var toLength = __webpack_require__(6);
var toIndex = __webpack_require__(104);
var gOPN = __webpack_require__(41).f;
var dP = __webpack_require__(7).f;
var arrayFill = __webpack_require__(58);
var setToStringTag = __webpack_require__(35);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _viewportEmitter = __webpack_require__(21);

var _viewportEmitter2 = _interopRequireDefault(_viewportEmitter);

var _instance = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Require all layout scripts
var requireTest = __webpack_require__(212);
requireTest.keys().forEach(requireTest);

var breakpoints = window.CMTConfig.variables.breakpoints;

// Initialize viewport breakpoints

_viewportEmitter2.default.setBreakpoints('small', [['medium', '(min-width: ' + breakpoints.small + 'em)'], ['large', '(min-width: ' + breakpoints.medium + 'em)']]);

// Add layouts to the page instance when they're loaded
window.addEventListener('cmpb-layout-loaded', function (event) {
  _instance.page.addSection(event.layout);
});

window.cmtInitGoogleMaps = function () {
  var event = new window.CustomEvent('cmt-google-maps-initialize');
  window.dispatchEvent(event);
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _scrollTo = __webpack_require__(78);

var _scrollTo2 = _interopRequireDefault(_scrollTo);

var _scrollMotionEmitter = __webpack_require__(79);

var _viewportEmitter = __webpack_require__(21);

var _viewportEmitter2 = _interopRequireDefault(_viewportEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var goToTopBtn = document.querySelector('.go-to-top');
if (goToTopBtn) {
  goToTopBtn.addEventListener('click', function (event) {
    event.preventDefault();
    (0, _scrollTo2.default)(0, 250, function () {
      if (document.activeElement === goToTopBtn) {
        document.activeElement.blur();
      }
    });
  });

  var winHeight = window.innerHeight;
  var scrollMotionEmitter = new _scrollMotionEmitter.ScrollMotionEmitter({
    smooth: false,
    overrideScroll: false,
    min: winHeight / 2,
    max: winHeight,
    friction: 0
  });

  scrollMotionEmitter.on('update', function (a) {
    goToTopBtn.style.opacity = a.progress;
    if (a.progress === 0) {
      goToTopBtn.style.visibility = 'hidden';
    } else {
      goToTopBtn.style.visibility = 'visible';
    }
  });

  if (!scrollMotionEmitter.isRunning()) {
    scrollMotionEmitter.start();
    scrollMotionEmitter.handleScroll(); // Force initial scroll
  }

  var siteFooter = document.querySelector('.site-footer');
  var goToTopSticky = function goToTopSticky(scrollTop) {
    var height = siteFooter.offsetHeight;
    var scrollBottom = document.body.offsetHeight - scrollTop - _viewportEmitter2.default.clientHeight();
    if (scrollBottom < height) {
      goToTopBtn.classList.add('go-to-top-sticky');
      goToTopBtn.style.marginBottom = height + 'px';
    } else {
      goToTopBtn.classList.remove('go-to-top-sticky');
      goToTopBtn.style.marginBottom = '';
    }
  };
  _viewportEmitter2.default.on('scroll', function () {
    goToTopSticky(_viewportEmitter2.default.scrollY());
  });
  goToTopSticky(_viewportEmitter2.default.scrollY()); // Force initial sticky state
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof window.CustomEvent !== 'function') {
  var CustomEvent = function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ElementProto = window.Element.prototype;
if (typeof ElementProto.matches !== 'function') {
  ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
    var element = this;
    var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
    var index = 0;
    while (elements[index] && elements[index] !== element) {
      ++index;
    }
    return Boolean(elements[index]);
  };
}

if (typeof ElementProto.closest !== 'function') {
  ElementProto.closest = function closest(selector) {
    var element = this;
    while (element && element.nodeType === 1) {
      if (element.matches(selector)) {
        return element;
      }
      element = element.parentNode;
    }
    return null;
  };
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sectionText = document.querySelector('.section-menu-text');
if (sectionText) {
  var onCurrentLayoutChange = function onCurrentLayoutChange(newLayout, prevLayout) {
    sectionText.innerHTML = newLayout.title;
    var computed = window.getComputedStyle(sectionText);
    sectionText.style.maxWidth = parseFloat(computed.width) + 'px';
  };
  window.addEventListener('cmpb-layout-changed', function (event) {
    onCurrentLayoutChange(event.layout, event.prevLayout);
  });
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Learn more: https://git.io/vWdr2
var isIe = /(trident|msie)/i.test(navigator.userAgent);
if (isIe) {
  window.addEventListener('hashchange', function () {
    var id = window.location.hash.substring(1);
    var element;
    if (!/^[A-z0-9_-]+$/.test(id)) {
      return;
    }
    element = document.getElementById(id);
    if (element) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
        element.tabIndex = -1;
      }
      element.focus();
    }
  }, false);
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(80) });

__webpack_require__(29)('copyWithin');


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(58) });

__webpack_require__(29)('fill');


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(39)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(29)(KEY);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(39)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(29)(KEY);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(14);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(13);
var call = __webpack_require__(90);
var isArrayIter = __webpack_require__(65);
var toLength = __webpack_require__(6);
var createProperty = __webpack_require__(60);
var getIterFn = __webpack_require__(75);

$export($export.S + $export.F * !__webpack_require__(48)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(60);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(4)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(8) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(81);
var validate = __webpack_require__(37);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(45)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(93);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(67);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(66);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(241) });


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(93) });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(67) });


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(66);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(66);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(88) });


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(88);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(95) });


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(1);
var meta = __webpack_require__(18).onFreeze;

__webpack_require__(11)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(12);
var $getOwnPropertyDescriptor = __webpack_require__(15).f;

__webpack_require__(11)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(11)('getOwnPropertyNames', function () {
  return __webpack_require__(96).f;
});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(13);
var $getPrototypeOf = __webpack_require__(33);

__webpack_require__(11)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(1);

__webpack_require__(11)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(1);

__webpack_require__(11)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(1);

__webpack_require__(11)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(100) });


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(13);
var $keys = __webpack_require__(26);

__webpack_require__(11)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(1);
var meta = __webpack_require__(18).onFreeze;

__webpack_require__(11)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(1);
var meta = __webpack_require__(18).onFreeze;

__webpack_require__(11)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(69).set });


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(25);
var global = __webpack_require__(3);
var ctx = __webpack_require__(14);
var classof = __webpack_require__(44);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(1);
var aFunction = __webpack_require__(22);
var anInstance = __webpack_require__(30);
var forOf = __webpack_require__(47);
var speciesConstructor = __webpack_require__(52);
var task = __webpack_require__(73).set;
var microtask = __webpack_require__(242)();
var newPromiseCapabilityModule = __webpack_require__(94);
var perform = __webpack_require__(244);
var userAgent = __webpack_require__(53);
var promiseResolve = __webpack_require__(245);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(34)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(35)($Promise, PROMISE);
__webpack_require__(51)(PROMISE);
Wrapper = __webpack_require__(23)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(48)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(22);
var anObject = __webpack_require__(2);
var rApply = (__webpack_require__(3).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(4)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(40);
var aFunction = __webpack_require__(22);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(1);
var fails = __webpack_require__(4);
var bind = __webpack_require__(237);
var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(7);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(43);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(4)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(15).f;
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(15);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(33);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(15);
var getPrototypeOf = __webpack_require__(33);
var has = __webpack_require__(9);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(1);
var anObject = __webpack_require__(2);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(99) });


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(69);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(7);
var gOPD = __webpack_require__(15);
var getPrototypeOf = __webpack_require__(33);
var has = __webpack_require__(9);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(27);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(1);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(8) && /./g.flags != 'g') __webpack_require__(7).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(83)
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toLength = __webpack_require__(6);
var advanceStringIndex = __webpack_require__(57);
var regExpExec = __webpack_require__(50);

// @@match logic
__webpack_require__(46)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toObject = __webpack_require__(13);
var toLength = __webpack_require__(6);
var toInteger = __webpack_require__(20);
var advanceStringIndex = __webpack_require__(57);
var regExpExec = __webpack_require__(50);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(46)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var sameValue = __webpack_require__(100);
var regExpExec = __webpack_require__(50);

// @@search logic
__webpack_require__(46)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(89);
var anObject = __webpack_require__(2);
var speciesConstructor = __webpack_require__(52);
var advanceStringIndex = __webpack_require__(57);
var toLength = __webpack_require__(6);
var callRegExpExec = __webpack_require__(50);
var regexpExec = __webpack_require__(68);
var fails = __webpack_require__(4);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(46)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(81);
var validate = __webpack_require__(37);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(45)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(101)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(6);
var context = __webpack_require__(72);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(63)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(36);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(72);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(63)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(12);
var toLength = __webpack_require__(6);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(103)
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(6);
var context = __webpack_require__(72);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(63)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(19);
var META = __webpack_require__(18).KEY;
var $fails = __webpack_require__(4);
var shared = __webpack_require__(71);
var setToStringTag = __webpack_require__(35);
var uid = __webpack_require__(28);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(106);
var wksDefine = __webpack_require__(246);
var enumKeys = __webpack_require__(238);
var isArray = __webpack_require__(87);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(1);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(43);
var createDesc = __webpack_require__(27);
var _create = __webpack_require__(40);
var gOPNExt = __webpack_require__(96);
var $GOPD = __webpack_require__(15);
var $DP = __webpack_require__(7);
var $keys = __webpack_require__(26);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(41).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(42).f = $propertyIsEnumerable;
  __webpack_require__(49).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(25)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(74);
var buffer = __webpack_require__(105);
var anObject = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(36);
var toLength = __webpack_require__(6);
var isObject = __webpack_require__(1);
var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
var speciesConstructor = __webpack_require__(52);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(4)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(51)(ARRAY_BUFFER);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(39)(0);
var redefine = __webpack_require__(19);
var meta = __webpack_require__(18);
var assign = __webpack_require__(95);
var weak = __webpack_require__(82);
var isObject = __webpack_require__(1);
var fails = __webpack_require__(4);
var validate = __webpack_require__(37);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(45)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(82);
var validate = __webpack_require__(37);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(45)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(59)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(29)('includes');


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(98)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(99);
var toIObject = __webpack_require__(12);
var gOPD = __webpack_require__(15);
var createProperty = __webpack_require__(60);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(98)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(102);
var userAgent = __webpack_require__(53);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(102);
var userAgent = __webpack_require__(53);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(54);
var getKeys = __webpack_require__(26);
var redefine = __webpack_require__(19);
var global = __webpack_require__(3);
var hide = __webpack_require__(10);
var Iterators = __webpack_require__(32);
var wks = __webpack_require__(5);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(73);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(53);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./interaction/googlemap.js": 213,
	"./multimedia/slideshow.js": 214,
	"./multimedia/video.js": 215
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var gmapsLoaded = false;

function GoogleMapLabel(options) {
  // Initialization
  this.setValues(options);

  // Label specific
  var span = this.span_ = document.createElement('span');
  span.className = 'google-map-label';

  var div = this.div_ = document.createElement('div');
  div.appendChild(span);
  div.style.cssText = 'position: absolute; display: none';
}

window.addEventListener('cmt-google-maps-initialize', function () {
  var google = window.google;
  // Define the overlay, derived from google.maps.OverlayView
  GoogleMapLabel.prototype = new google.maps.OverlayView();

  // Implement onAdd
  GoogleMapLabel.prototype.onAdd = function () {
    var _this = this;

    var pane = this.getPanes().overlayLayer;
    pane.appendChild(this.div_);

    // Ensures the label is redrawn if the text or position is changed.
    this.listeners_ = [google.maps.event.addListener(this, 'position_changed', function () {
      _this.draw();
    }), google.maps.event.addListener(this, 'text_changed', function () {
      _this.draw();
    })];
  };

  // Implement onRemove
  GoogleMapLabel.prototype.onRemove = function () {
    this.div_.parentNode.removeChild(this.div_);

    // Label is removed from the map, stop updating its position/text.
    for (var i = 0, I = this.listeners_.length; i < I; ++i) {
      google.maps.event.removeListener(this.listeners_[i]);
    }
  };

  // Implement draw
  GoogleMapLabel.prototype.draw = function () {
    var projection = this.getProjection();
    var position = projection.fromLatLngToDivPixel(this.get('position'));

    var div = this.div_;
    div.style.left = position.x + 'px';
    div.style.top = position.y + 'px';
    div.style.display = 'block';

    this.span_.innerHTML = this.get('text').toString();
  };

  // Dispatch Custom Event
  gmapsLoaded = true;
  initializeMaps();
});

var _remSize = false;
function remSize() {
  if (!_remSize) {
    _remSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
  }
  return _remSize;
}

var initializeMap = function initializeMap(wrap) {
  var google = window.google;
  wrap.dataset.initialized = true;

  var zoom = parseFloat(wrap.dataset.zoom);
  var baseHeight = parseFloat(wrap.dataset.baseHeight) * remSize();
  // Take scale into account to make roughly the same part of the map visible
  zoom = Math.max(1, Math.floor(zoom - Math.sqrt(baseHeight / wrap.clientHeight) + 1));
  var mapCanvas = wrap.querySelector('.google-map-canvas');
  var mapOptions = {
    scaleControl: false,
    center: new google.maps.LatLng(wrap.dataset.lat, wrap.dataset.lng),
    zoom: zoom,
    minZoom: 1,
    gestureHandling: 'cooperative',
    mapTypeControl: false,
    streetViewControl: false,
    styles: window.CMTGMapStyles || []
  };

  var map = new google.maps.Map(mapCanvas, mapOptions);

  var markers = JSON.parse(wrap.dataset.markers);
  if (!markers.length) {
    return;
  }

  var activeInfoWindow = void 0;

  var _loop = function _loop(settings) {
    var title = settings.title || '';
    var content = settings.content || '';
    var icon = settings.icon || '';
    var url = settings.url || '';

    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(settings.position.lat, settings.position.lng),
      map: map,
      title: title,
      icon: icon
    });

    var contentString = '\n      <div class="google-map-box-wrap">\n        <p class="google-map-box-heading">' + title + '</p>\n        <div class="google-map-box-content">\n          <p>' + content + '</p>\n        </div>\n      </div>\n    ';

    var infowindow = new google.maps.InfoWindow({
      content: contentString
    });

    marker.addListener('click', function () {
      if (activeInfoWindow) {
        if (activeInfoWindow === infowindow) {
          if (url) {
            window.location.href = url;
          }
          return;
        }
        activeInfoWindow.close();
      }
      activeInfoWindow = infowindow;
      if (title || content) {
        infowindow.open(map, marker);
      }
    });

    infowindow.addListener('closeclick', function () {
      if (activeInfoWindow === infowindow) {
        activeInfoWindow = null;
      }
    });

    // Add label if title is set
    if (title) {
      var label = new GoogleMapLabel({
        map: map
      });
      label.bindTo('position', marker, 'position');
      label.bindTo('text', marker, 'title');
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = markers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var settings = _step.value;

      _loop(settings);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

function initializeMaps(layout) {
  if (!layout) {
    layout = document;
  }
  var maps = layout.querySelectorAll('.google-map[data-initialized="false"]');
  for (var i = 0; i < maps.length; i++) {
    initializeMap(maps[i]);
  }
}

window.addEventListener('cmpb-layout-loaded', function (event) {
  if (gmapsLoaded) {
    initializeMaps(event.layout);
  }
});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var videojs = void 0;

var Slideshow = function () {
  function Slideshow(container) {
    _classCallCheck(this, Slideshow);

    this.container = container;
    this.timeout = null;
    this.prevSlide = null;
    this.crntSlide = null;
    this.classes = {
      crntSlide: 'slide-crnt',
      prevSlide: 'slide-prev',
      crntButton: 'slide-btn-crnt'
    };
    this.durationAttribute = 'duration';
    this.defaultDuration = 4000;

    var slidesContainer = container.querySelector('.slides');
    this.usesTouch = slidesContainer.classList.contains('slides-touch');
    this.slides = [].concat(_toConsumableArray(slidesContainer.children));

    if (this.slides.length <= 1) {
      return;
    }
    this._initialize();
  }

  _createClass(Slideshow, [{
    key: '_initialize',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, slide;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 3;
                _iterator = this.slides[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 12;
                  break;
                }

                slide = _step.value;
                _context.next = 9;
                return this.initializeSlide(slide);

              case 9:
                _iteratorNormalCompletion = true;
                _context.next = 5;
                break;

              case 12:
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 18:
                _context.prev = 18;
                _context.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context.prev = 21;

                if (!_didIteratorError) {
                  _context.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context.finish(21);

              case 25:
                return _context.finish(18);

              case 26:
                this.slideIndex = -1;
                this.initializeControllers();
                this._ready = true;
                if (this._running) {
                  this.start();
                }

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14, 18, 26], [19,, 21, 25]]);
      }));

      function _initialize() {
        return _ref.apply(this, arguments);
      }

      return _initialize;
    }()
  }, {
    key: 'initializeSlide',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(slide) {
        var _this = this;

        var video;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                video = slide.querySelector('video');

                if (!video) {
                  _context2.next = 15;
                  break;
                }

                if (videojs) {
                  _context2.next = 13;
                  break;
                }

                _context2.prev = 3;
                _context2.next = 6;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 211));

              case 6:
                videojs = _context2.sent;
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                console.error(_context2.t0);
                return _context2.abrupt('return');

              case 13:
                slide.player = videojs(video, {}, function () {
                  if (_this.crntSlide === slide) {
                    // It does not like playing the video unless a timeout is provided
                    setTimeout(function () {
                      slide.player.play();
                      slide.playerReady = true;
                    }, 0);
                  } else {
                    slide.playerReady = true;
                  }
                });
                slide.player.on('ended', function () {
                  if (_this.crntSlide === slide) {
                    _this.slide();
                  }
                });

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function initializeSlide(_x) {
        return _ref2.apply(this, arguments);
      }

      return initializeSlide;
    }()
  }, {
    key: 'setController',
    value: function setController(element, index) {
      var _this2 = this;

      element.addEventListener('click', function (e) {
        _this2.slide(index);
      });
    }
  }, {
    key: 'initializeControllers',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var controllersContainer, i, Hammer, userSelect, hammertime;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                controllersContainer = this.container.querySelector('.slides-controller');

                if (controllersContainer) {
                  this.controllers = [].concat(_toConsumableArray(controllersContainer.children));
                } else {
                  this.controllers = null;
                }

                if (this.controllers) {
                  for (i = 0; i < this.controllers.length; i++) {
                    this.setController(this.controllers[i], i);
                  }
                }

                if (!this.usesTouch) {
                  _context3.next = 20;
                  break;
                }

                Hammer = void 0;
                _context3.prev = 5;
                _context3.next = 8;
                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 249));

              case 8:
                Hammer = _context3.sent;
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](5);

                console.error(_context3.t0);
                return _context3.abrupt('return');

              case 15:
                userSelect = Hammer.defaults.cssProps.userSelect;

                delete Hammer.defaults.cssProps.userSelect;
                hammertime = new Hammer(this.container, {
                  inputClass: Hammer.TouchInput,
                  recognizers: [[Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }]]
                });

                Hammer.defaults.cssProps.userSelect = userSelect;
                hammertime.on('swipe', function (ev) {
                  if (ev.direction === Hammer.DIRECTION_LEFT) {
                    _this3.slide(_this3.slideIndex + 1);
                  } else if (ev.direction === Hammer.DIRECTION_RIGHT) {
                    _this3.slide(_this3.slideIndex - 1);
                  }
                });

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));

      function initializeControllers() {
        return _ref3.apply(this, arguments);
      }

      return initializeControllers;
    }()
  }, {
    key: 'start',
    value: function start() {
      this._running = true;
      if (!this._ready) {
        return;
      }
      this.slide(true);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this._running = false;
      window.clearTimeout(this.timeout);
    }
  }, {
    key: 'slide',
    value: function slide(index) {
      if (this.slides.length <= 1) {
        return;
      }
      window.clearTimeout(this.timeout);
      if (typeof index === 'undefined') {
        index = true;
      }

      if (this.prevSlide) {
        this.prevSlide.classList.remove(this.classes.prevSlide);
      }
      if (this.crntSlide) {
        this.crntSlide.classList.remove(this.classes.crntSlide);
        this.crntSlide.classList.add(this.classes.prevSlide);
        this.prevSlide = this.crntSlide;
      }
      if (index === true) {
        this.slideIndex += 1;
      } else if (index === false) {
        this.slideIndex -= 1;
      } else {
        this.slideIndex = index;
      }
      this.slideIndex = this.slideIndex % this.slides.length;
      while (this.slideIndex < 0) {
        this.slideIndex = this.slides.length + this.slideIndex;
      }
      this.crntSlide = this.slides[this.slideIndex];
      this.crntSlide.classList.remove(this.classes.prevSlide);
      this.crntSlide.classList.add(this.classes.crntSlide);
      if (this.controllers) {
        for (var i = 0; i < this.controllers.length; i++) {
          if (this.slideIndex === i) {
            this.controllers[i].classList.add(this.classes.crntButton);
          } else {
            this.controllers[i].classList.remove(this.classes.crntButton);
          }
        }
      }
      if (this.prevSlide && this.prevSlide.player) {
        // Pause video on previous slide
        this.prevSlide.player.pause();
      }
      if (this.crntSlide.player && this.crntSlide.playerReady) {
        // Go to start & play on current slide
        this.crntSlide.player.currentTime(0);
        this.crntSlide.player.play();
      }

      // Set timeout for next slide
      var slideDuration = this.defaultDuration;
      if (this.crntSlide.hasAttribute('data-' + this.durationAttribute)) {
        slideDuration = parseInt(this.crntSlide.getAttribute('data-' + this.durationAttribute));
      }
      if (slideDuration > 0) {
        this.timeout = setTimeout(this.slide.bind(this), slideDuration);
      }
    }
  }]);

  return Slideshow;
}();

window.addEventListener('cmpb-layout-loaded', function (event) {
  var sliders = event.layout.querySelectorAll('.slider-wrap');
  for (var i = 0, l = sliders.length; i < l; i++) {
    var slideshow = new Slideshow(sliders[i]);
    slideshow.start();
  }
});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var videojs = void 0;

// Initialize uninitialized video blocks whenever a layout is loaded
window.addEventListener('cmpb-layout-loaded', function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
    var videos, _loop, _arr, _i, video;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            videos = event.layout.querySelectorAll('.cmpb-block-video .video-js');

            if (videos.length) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return');

          case 3:
            if (videojs) {
              _context.next = 14;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 211));

          case 7:
            videojs = _context.sent;
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](4);

            console.error(_context.t0);
            return _context.abrupt('return');

          case 14:
            _loop = function _loop(video) {
              var player = videojs(video);
              player.ready(function () {
                if (player.autoplay() && player.paused()) {
                  // BUG Autoplay is paused when vjs is initialized in chrome, so we start playing again
                  player.play();
                } else {
                  // HACK solution for issue https://github.com/videojs/video.js/issues/4193
                  if (player.autoplay() && !player.paused() && player.hasClass('vjs-paused')) {
                    player.pause();
                    player.play();
                  }
                }
              });
            };

            _arr = [].concat(_toConsumableArray(videos));

            for (_i = 0; _i < _arr.length; _i++) {
              video = _arr[_i];

              _loop(video);
            }

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[4, 10]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NAME_PREFIX = '_cmt-form-';

var CMTForm = function () {
  function CMTForm(form) {
    var _this = this;

    _classCallCheck(this, CMTForm);

    if (form.dataset.formInitialized) {
      console.warn('CMTForm: Same form was initialized twice.');
    } else {
      form.dataset.formInitialized = true;
      this.element = form;
      this.submitElements = form.querySelectorAll('[type="submit"]');
      this.responseElement = form.querySelector('.cmt-form-response');
      this.inputs = form.elements;
      this.strings = JSON.parse(form.dataset.strings);
      this._disabled = false;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (_this._disabled) {
          return false;
        }
        _this.handleSubmit();
      });
      var event = new window.CustomEvent('cmt-form-initialized', {
        'bubbles': true,
        'cancelable': false,
        'detail': {
          form: this,
          form_id: this.inputs['cmt-form'].value,
          form_uid: this.inputs['cmt-form-uid'].value
        }
      });
      window.dispatchEvent(event);
    }
  }

  _createClass(CMTForm, [{
    key: 'disableSubmit',
    value: function disableSubmit() {
      this._disabled = true;
      for (var i = 0, l = this.submitElements.length; i < l; i++) {
        this.submitElements[i].disabled = true;
      }
    }
  }, {
    key: 'enableSubmit',
    value: function enableSubmit() {
      this._disabled = false;
      for (var i = 0, l = this.submitElements.length; i < l; i++) {
        this.submitElements[i].disabled = false;
      }
    }
  }, {
    key: 'getInputByName',
    value: function getInputByName(name) {
      return this.inputs[NAME_PREFIX + name];
    }
  }, {
    key: 'getValues',
    value: function getValues() {
      var values = {};
      for (var i = 0; i < this.inputs.length; i++) {
        var input = this.inputs[i];
        var value = void 0;
        if (input.tagName === 'SELECT') {
          value = input.options[input.selectedIndex].value;
        } else if (input.tagName === 'INPUT' && (input.type === 'radio' || input.type === 'checkbox')) {
          if (input.checked) {
            value = input.value;
          } else {
            continue;
          }
        } else {
          value = input.value;
        }
        values[input.name] = value;
      }
      return values;
    }
  }, {
    key: 'buildQuery',
    value: function buildQuery() {
      var values = this.getValues();
      var query = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.keys(values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          query.push(key + '=' + encodeURIComponent(values[key]));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return query.join('&');
    }
  }, {
    key: 'setResponse',
    value: function setResponse(message, success) {
      this.responseElement.innerHTML = message;
      if (success) {
        this.responseElement.classList.add('cmt-form-success');
      } else {
        this.responseElement.classList.add('cmt-form-failure');
      }
    }
  }, {
    key: 'setSending',
    value: function setSending() {
      this.responseElement.classList.remove('cmt-form-success');
      this.responseElement.classList.remove('cmt-form-failure');
      this.responseElement.innerHTML = this.strings.sending;
    }
  }, {
    key: 'handleResponse',
    value: function handleResponse(status, response) {
      if (status === 200) {
        var resp = JSON.parse(response);
        console.log(resp);
        if (resp.success === true) {
          this.setResponse(this.strings.sent, true);
          // Create the event.
          var event = new window.CustomEvent('cmt-form-sent', {
            'bubbles': true,
            'cancelable': false,
            'detail': {
              form: this,
              form_id: this.inputs['cmt-form'].value,
              form_uid: this.inputs['cmt-form-uid'].value
            }
          });
          window.dispatchEvent(event);
        } else {
          var err = void 0;
          if (!resp.errors || !resp.errors.length) {
            err = this.strings.error;
          } else {
            err = resp.errors.join('<br>');
          }
          this.setResponse(err, false);
          this.enableSubmit();
        }
      } else {
        this.setResponse(this.strings.error, false);
        this.enableSubmit();
      }
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var _this2 = this;

      this.disableSubmit();
      this.setSending();
      var xmlhttp = new window.XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4) {
          _this2.handleResponse(xmlhttp.status, xmlhttp.response);
        }
      };
      xmlhttp.open('POST', window.CMTConfig.rest + 'form/send', true);
      xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xmlhttp.send(this.buildQuery());
    }
  }]);

  return CMTForm;
}();

module.exports = CMTForm;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global CMTConfig */


var choicesPerHour = 4;
var l18n = CMTConfig.l18n;

var yearOffset = new Date().getFullYear();

function now() {
  return new Date();
}

function getDaysInMonth(year, month) {
  return new Date(Date.UTC(year, month + 1, 0)).getDate();
}

var DateInput = function (_EventEmitterMicro) {
  _inherits(DateInput, _EventEmitterMicro);

  function DateInput(yearInput, monthInput, dayInput, timeInput) {
    _classCallCheck(this, DateInput);

    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this));

    _this.yearInput = yearInput;
    _this.monthInput = monthInput;
    _this.dayInput = dayInput;
    _this.timeInput = timeInput;

    // We remove the required field. It causes issues with firefox, and the fields are always set anyway
    yearInput.required = false;
    monthInput.required = false;
    dayInput.required = false;

    _this.years = _this.yearInput.children.length;

    _this.yearInput.addEventListener('change', function () {
      _this.setFirstAvailable(false); // Do not modify year
      _this.handleChange();
    });
    _this.monthInput.addEventListener('change', function () {
      _this.setFirstAvailable(false, false); // Do not modify year & month
      _this.handleChange();
    });
    _this.dayInput.addEventListener('change', function () {
      _this.setFirstAvailable(false, false, false); // Do not modify year, month & day
      _this.handleChange();
    });
    if (_this.timeInput) {
      _this.timeInput.required = false;
      _this.timeInput.addEventListener('change', function () {
        _this.trigger('change');
      });
    }
    return _this;
  }

  _createClass(DateInput, [{
    key: 'initializeAvailability',
    value: function initializeAvailability(openingHours, floor, ceiling) {
      floor += l18n.timezone.offs * 1000 * 60 * 60; // Add timezone offset
      ceiling += l18n.timezone.offs * 1000 * 60 * 60; // Add timezone offset
      var availability = {
        years: {}
      };
      var dateNow = now();

      var dateNowWithoutTime = now();
      dateNowWithoutTime.setUTCHours(0, 0, 0, 0);
      dateNowWithoutTime = dateNowWithoutTime.getTime();

      for (var year = yearOffset; year < yearOffset + this.years; year++) {
        var yearData = [];
        for (var month = 0; month < 12; month++) {
          var daysInMonth = getDaysInMonth(year, month);
          var monthData = [];
          for (var day = 0; day < 31; day++) {
            if (day >= daysInMonth) {
              monthData[day] = false;
              continue;
            }
            var date = new Date(Date.UTC(year, month, day + 1));
            var weekDay = (date.getUTCDay() || 7) - 1;
            date = date.getTime();

            var dayData = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = openingHours[weekDay][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var spanConfig = _step.value;

                var span = spanConfig.slice(0);

                if (date < dateNowWithoutTime) {
                  // Date has passed, it's not available
                  continue;
                } else if (date >= ceiling) {
                  // Date is past the ceiling, it's not available
                  continue;
                } else if (span[0] === 0 && span[1] === 0) {
                  // The timespan is 00:00-00:00, it's always closed
                  continue;
                } else if (date === dateNowWithoutTime) {
                  // It's the current date (Is this necessary with the new time floor code? probably not)
                  if (dateNow.getUTCHours() >= span[1]) {
                    // It's past the closing time
                    continue;
                  }
                }

                // Date is available, check time floor

                // Calculate how many hours into the day you must be
                var time = (floor - date) / 1000 / 60 / 60;

                // And use the greatest value
                span[0] = Math.max(span[0], time);

                // Make sure that the time aligns with choices per hour
                span[0] = Math.ceil(span[0] * choicesPerHour) / choicesPerHour;

                if (span[0] > span[1]) {
                  // It opens after it closes
                  continue;
                }

                dayData.push(span);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (dayData.length) {
              monthData[day] = dayData;
            } else {
              monthData[day] = false;
            }
          }
          if (!monthData.some(function (element) {
            return (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object';
          })) {
            // All days are closed
            monthData = false;
          }
          yearData[month] = monthData;
        }
        if (!yearData.some(function (element) {
          return element !== false;
        })) {
          // All months are closed
          yearData = false;
        }
        availability.years[year] = yearData;
      }
      this.availability = availability;
    }
  }, {
    key: 'handleChange',
    value: function handleChange() {
      this.refreshAvailability();
      this.refreshWeekdays();
      this.trigger('change');
    }
  }, {
    key: 'setFirstAvailable',
    value: function setFirstAvailable() {
      var setYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var setMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var setDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var setTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var currentYear = this.getYear();
      var currentMonth = this.getMonth();
      var currentDay = this.getDay();

      // Check Year
      var availability = this.availability.years;
      if (setYear && availability[currentYear] === false) {
        // Current year is unavailable
        var newYear = currentYear;
        while (++newYear) {
          if (!(newYear in availability)) {
            // We're past the last year, wrap around to the first one
            newYear = yearOffset;
          }
          if (availability[newYear] !== false) {
            // The year is available
            break;
          }
          if (newYear === currentYear) {
            // We've gone one cycle without finding an available year
            console.error('DateInput: Could not find an available year');
            return;
          }
        }
        this.setYear(newYear);
        currentYear = newYear;
      }

      // Check Month
      var yearData = availability[currentYear];
      if (setMonth && yearData[currentMonth] === false) {
        // Current month is unavailable
        var newMonth = currentMonth;
        var step = 1;
        while (newMonth += step) {
          if (newMonth > 11) {
            // We're past the last month, try the opposite direction
            newMonth = currentMonth - 1;
            step = -1;
          }
          if (newMonth < 0) {
            // We've tried all months without finding an available one
            console.error('DateInput: Could not find an available month');
            return;
          }
          if (yearData[newMonth] !== false) {
            // The month is available
            break;
          }
        }
        this.setMonth(newMonth);
        currentMonth = newMonth;
      }

      // Check Day
      var monthData = yearData[currentMonth];
      if (setDay && monthData[currentDay] === false) {
        // Current day is unavailable
        var newDay = currentDay;
        var _step2 = 1;
        while (newDay += _step2) {
          if (newDay >= monthData.length) {
            // We're past the last day, try the opposite direction
            newDay = currentDay - 1;
            _step2 = -1;
          }
          if (newDay < 0) {
            // We've tried all days without finding an available one
            console.error('DateInput: Could not find an available day');
            return;
          }
          if (monthData[newDay] !== false) {
            // The day is available
            break;
          }
        }
        this.setDay(newDay);
        currentDay = newDay;
      }

      // Check Time
      if (this.timeInput && setTime) {
        var currentTime = this.getTime();
        // TODO: Add support for several spans
        var span = monthData[currentDay][0];
        var start = span[0] * choicesPerHour;
        var end = span[1] * choicesPerHour;
        if (currentTime < start || currentTime > end) {
          // Current time is unavailable
          var newTime = currentTime;
          var _step3 = 1;
          while (newTime += _step3) {
            if (newTime >= 24 * choicesPerHour) {
              // We're past the last time, try the opposite direction
              newTime = currentTime - 1;
              _step3 = -1;
            }
            if (newTime < 0) {
              // We've tried all times without finding an available one
              console.error('DateInput: Could not find an available time');
              return;
            }
            if (newTime >= start && newTime <= end) {
              // The time is available
              break;
            }
          }
          this.setTime(newTime);
          currentTime = newTime;
        }
      }
    }
  }, {
    key: 'refreshAvailability',
    value: function refreshAvailability() {
      var currentYear = this.getYear();
      var currentMonth = this.getMonth();
      var currentDay = this.getDay();

      // Update year inputs
      var availability = this.availability.years;
      for (var i = 0; i < this.years; i++) {
        this.yearInput.children[i].disabled = availability[yearOffset + i] === false;
      }

      // Update month inputs
      var currentYearIsUnavailable = availability[currentYear] === false;
      for (var _i = 0; _i < 12; _i++) {
        this.monthInput.children[_i].disabled = currentYearIsUnavailable || availability[currentYear][_i] === false;
      }

      // Update day inputs
      var currentMonthIsUnavailable = currentYearIsUnavailable || availability[currentYear][currentMonth] === false;
      var daysInMonth = getDaysInMonth(currentYear, currentMonth);
      if (daysInMonth !== this.dayInput.length) {
        if (this.dayInput.length < daysInMonth) {
          // There are missing dates, add them
          for (var _i2 = this.dayInput.length; _i2 < daysInMonth; _i2++) {
            var element = document.createElement('option');
            element.value = _i2;
            this.dayInput.appendChild(element);
          }
        } else if (this.dayInput.length > daysInMonth) {
          // There are unavailable dates present, remove them
          for (var _i3 = this.dayInput.length; _i3 > daysInMonth; _i3--) {
            this.dayInput.removeChild(this.dayInput.children[_i3 - 1]);
          }
        }
      }
      for (var _i4 = 0, l = this.dayInput.length; _i4 < l; _i4++) {
        var _element = this.dayInput[_i4];
        var disabled = currentMonthIsUnavailable || availability[currentYear][currentMonth][_i4] === false;
        _element.disabled = disabled;
      }

      // Update time inputs
      if (this.timeInput) {
        // TODO: Add support for several spans
        var span = availability[currentYear][currentMonth][currentDay][0];
        var currentDayIsUnavailable = currentMonthIsUnavailable || span === false;
        if (currentDayIsUnavailable) {
          // data is unavailable, clear all time inputs; this should never happen
          for (var _i5 = 0, _l = this.timeInput.children.length; _i5 < _l; _i5++) {
            this.timeInput.removeChild(this.timeInput.children[0]);
          }
        } else {
          var start = span[0] * choicesPerHour;
          var end = span[1] * choicesPerHour;
          // Check if number of choices has changed, OR the first choice is different
          // NOTE: When multiple spans are allowed, this check will have to change
          if (end - start !== this.timeInput.length - 1 || parseInt(this.timeInput[0].value) !== start) {
            // If it is, clear all time options
            for (var _i6 = 0, _l2 = this.timeInput.children.length; _i6 < _l2; _i6++) {
              this.timeInput.removeChild(this.timeInput.children[0]);
            }
            // And add time all time options that should be present
            for (var _i7 = start; _i7 <= end; _i7++) {
              var _element2 = document.createElement('option');
              _element2.value = _i7;
              var minutes = _i7 * 60 / choicesPerHour;
              var m = Math.floor(minutes % 60);
              var h = Math.floor(minutes / 60);

              var stamp = ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2);
              _element2.innerHTML = stamp + ' ' + l18n.timezone.abbr;
              this.timeInput.appendChild(_element2);
            }
          }
        }
      }
    }
  }, {
    key: 'refreshWeekdays',
    value: function refreshWeekdays() {
      var currentYear = this.getYear();
      var currentMonth = this.getMonth();
      for (var i = 0; i < 31; i++) {
        var element = this.dayInput.children[i];
        if (element) {
          var weekday = (new Date(Date.UTC(currentYear, currentMonth, i + 1)).getDay() || 7) - 1;
          element.innerHTML = i + 1 + ' (' + l18n.weekday[weekday] + ')';
        }
      }
    }
  }, {
    key: 'setYear',
    value: function setYear(year) {
      this.yearInput.value = year - yearOffset;
      return year;
    }
  }, {
    key: 'getYear',
    value: function getYear() {
      return parseInt(this.yearInput.value) + yearOffset;
    }
  }, {
    key: 'setMonth',
    value: function setMonth(month) {
      this.monthInput.value = month;
      return month;
    }
  }, {
    key: 'getMonth',
    value: function getMonth() {
      return parseInt(this.monthInput.value);
    }
  }, {
    key: 'setDay',
    value: function setDay(day) {
      this.dayInput.value = day;
      return day;
    }
  }, {
    key: 'getDay',
    value: function getDay() {
      return parseInt(this.dayInput.value);
    }
  }, {
    key: 'setTime',
    value: function setTime(time) {
      if (this.timeInput) {
        this.timeInput.value = time;
      }
      return time;
    }
  }, {
    key: 'getTime',
    value: function getTime() {
      if (!this.timeInput) {
        return 0;
      }
      return parseInt(this.timeInput.value);
    }
  }, {
    key: 'getDate',
    value: function getDate() {
      var time = this.getTime() / choicesPerHour;
      var hours = Math.floor(time);
      var minutes = (time - hours) * 60;
      return new Date(Date.UTC(this.getYear(), this.getMonth(), this.getDay() + 1, hours, minutes));
    }
  }]);

  return DateInput;
}(_eventEmitterMicro2.default);

exports.default = DateInput;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateInput = __webpack_require__(217);

var _dateInput2 = _interopRequireDefault(_dateInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: provide as data-availability attribute on form element
//       Requires CMTForm to allow setting custom attributes on the form element
var hours = [[[0, 23.75]], [[0, 23.75]], [[0, 23.75]], [[0, 23.75]], [[0, 23.75]], [[0, 23.75]], [[0, 23.75]]];

var DatePickerForm = function DatePickerForm(form) {
  _classCallCheck(this, DatePickerForm);

  this.form = form;

  this.dateInput = new _dateInput2.default(form.getInputByName('year'), form.getInputByName('month'), form.getInputByName('day'), form.getInputByName('time'));

  var hoursInAdvance = 0;
  var dateNowWithoutTime = new Date();
  dateNowWithoutTime.setUTCHours(0, 0, 0, 0);

  this.dateInput.initializeAvailability(hours, Date.now() + hoursInAdvance * 1000 * 60 * 60, +dateNowWithoutTime + 365 * 1000 * 60 * 60 * 24);
  this.dateInput.setFirstAvailable();
  this.dateInput.handleChange();
};

exports.default = DatePickerForm;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThrottledClock = exports.Clock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var startTime = new Date().getTime();

var Clock = exports.Clock = function (_EventEmitterMicro) {
  _inherits(Clock, _EventEmitterMicro);

  function Clock() {
    _classCallCheck(this, Clock);

    var _this = _possibleConstructorReturn(this, (Clock.__proto__ || Object.getPrototypeOf(Clock)).call(this));

    _this.lastFrameTime = null;
    _this._animationFrame = null;
    _this._active = false;
    _this._startTime = null;
    _this._boundOnAnimationFrame = _this._onAnimationFrame.bind(_this);
    _this._getTime = Date.now || function () {
      return new Date().getTime();
    };
    return _this;
  }

  _createClass(Clock, [{
    key: 'start',
    value: function start() {
      if (this._active) {
        return;
      }
      this._tick();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this._active) {
        window.cancelAnimationFrame(this._animationFrame);
      }
      this._animationFrame = null;
      this.lastFrameTime = null;
      this._active = false;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.stop();
      this.off();
      for (var prop in this) {
        if (this.hasOwnProperty(prop)) {
          this[prop] = null;
        }
      }
    }
  }, {
    key: 'isRunning',
    value: function isRunning() {
      return this._active;
    }
  }, {
    key: '_tick',
    value: function _tick() {
      if (!this._active) {
        this._active = true;
      }
      this._animationFrame = window.requestAnimationFrame(this._boundOnAnimationFrame);
    }
  }, {
    key: '_onAnimationFrame',
    value: function _onAnimationFrame(time) {
      var delta = 0;
      var timeNow = this._getTime();
      if (this.lastFrameTime === null) {
        this.lastFrameTime = timeNow - startTime;
      } else {
        delta = time - this.lastFrameTime;
      }
      var fps = 0;
      if (delta !== 0) {
        fps = 1000 / delta;
      }
      var naturalFps = fps;
      var event = { time: time, delta: delta, fps: fps, naturalFps: naturalFps, timeNow: timeNow };
      this.trigger('update', event);
      this.trigger('draw', event);
      this._animationFrame = null;
      this.lastFrameTime = time;
      if (this._active !== false) {
        this._tick();
      } else {
        this.lastFrameTime = null;
      }
    }
  }]);

  return Clock;
}(_eventEmitterMicro2.default);

var ThrottledClock = exports.ThrottledClock = function (_EventEmitterMicro2) {
  _inherits(ThrottledClock, _EventEmitterMicro2);

  function ThrottledClock(fps, options) {
    _classCallCheck(this, ThrottledClock);

    var _this2 = _possibleConstructorReturn(this, (ThrottledClock.__proto__ || Object.getPrototypeOf(ThrottledClock)).call(this));

    options = options || {};
    _this2._fps = fps || null;
    _this2._clock = options.clock || sharedClockInstance;
    _this2._lastThrottledTime = null;
    _this2._clockEvent = null;
    _this2._boundOnClockDraw = _this2._onClockDraw.bind(_this2);
    _this2._boundOnClockUpdate = _this2._onClockUpdate.bind(_this2);
    _this2._clock.on('update', _this2._boundOnClockUpdate);
    return _this2;
  }

  _createClass(ThrottledClock, [{
    key: 'setFps',
    value: function setFps(fps) {
      this._fps = fps;
      return this;
    }
  }, {
    key: 'getFps',
    value: function getFps() {
      return this._fps;
    }
  }, {
    key: 'start',
    value: function start() {
      this._clock.start();
      return this;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this._clock.stop();
      return this;
    }
  }, {
    key: 'isRunning',
    value: function isRunning() {
      return this._clock.isRunning();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._clock.off('update', this._boundOnClockUpdate);
      this._clock.destroy.call(this);
    }
  }, {
    key: '_onClockUpdate',
    value: function _onClockUpdate(event) {
      if (this._lastThrottledTime === null) {
        this._lastThrottledTime = this._clock.lastFrameTime;
      }
      var delta = event.time - this._lastThrottledTime;
      if (!this._fps) {
        throw new TypeError('FPS is not defined.');
      }
      if (delta < 1000 / this._fps) {
        return;
      }
      this._clockEvent = event;
      this._clockEvent.delta = delta;
      this._clockEvent.fps = 1000 / delta;
      this._lastThrottledTime = this._clockEvent.time;
      this._clock.once('draw', this._boundOnClockDraw);
      this.trigger('update', this._clockEvent);
    }
  }, {
    key: '_onClockDraw',
    value: function _onClockDraw() {
      this.trigger('draw', this._clockEvent);
    }
  }]);

  return ThrottledClock;
}(_eventEmitterMicro2.default);

var sharedClockInstance = new Clock();

exports.default = sharedClockInstance;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseComponent = function (_EventEmitterMicro) {
  _inherits(BaseComponent, _EventEmitterMicro);

  function BaseComponent(section, element, componentName, breakpoint, scrollPosition, windowHeight, index) {
    _classCallCheck(this, BaseComponent);

    if (arguments.length !== 7) {
      throw new Error("Incorrect number of arguments passed to BaseComponent check the constructor or BaseComponent.call method - argument's should be (section, element, componentName, breakpoint, scrollPosition, windowHeight, index)");
    }

    var _this = _possibleConstructorReturn(this, (BaseComponent.__proto__ || Object.getPrototypeOf(BaseComponent)).call(this));

    _this.section = section;
    _this.element = element;
    _this.componentName = componentName;
    _this.index = index;
    _this.isEnabled = true;
    _this.rafWhenVisible = _this.rafWhenVisible || false;
    return _this;
  }

  _createClass(BaseComponent, [{
    key: "destroy",
    value: function destroy() {
      this.teardownEvents();
      _get(BaseComponent.prototype.__proto__ || Object.getPrototypeOf(BaseComponent.prototype), "destory", this).call(this);
    }
  }, {
    key: "setupEvents",
    value: function setupEvents() {}
  }, {
    key: "teardownEvents",
    value: function teardownEvents() {}
  }, {
    key: "onSectionWillAppear",
    value: function onSectionWillAppear(scrollPosition, windowHeight) {}
  }, {
    key: "activate",
    value: function activate() {}
  }, {
    key: "animateIn",
    value: function animateIn() {}
  }, {
    key: "onRequestAnimationFrame",
    value: function onRequestAnimationFrame() {}
  }, {
    key: "deactivate",
    value: function deactivate() {}
  }, {
    key: "onScroll",
    value: function onScroll(event, scrollPosition, windowHeight) {}
  }, {
    key: "onSectionWillDisappear",
    value: function onSectionWillDisappear(scrollPosition, windowHeight) {}
  }, {
    key: "onResizeDebounced",
    value: function onResizeDebounced(event, scrollPosition, windowHeight) {}
  }, {
    key: "onResizeImmediate",
    value: function onResizeImmediate(event, scrollPosition, windowHeight) {}
  }, {
    key: "onOrientationChange",
    value: function onOrientationChange(event, orientation, scrollPosition, windowHeight) {}
  }, {
    key: "onBreakpoint",
    value: function onBreakpoint(to, from, scrollPosition, windowHeight) {}
  }]);

  return BaseComponent;
}(_eventEmitterMicro2.default);

exports.default = BaseComponent;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollAnimation = __webpack_require__(222);

Object.defineProperty(exports, 'ScrollAnimation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_scrollAnimation).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseComponent = __webpack_require__(220);

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _scrollAnimation = __webpack_require__(231);

var _scrollAnimation2 = _interopRequireDefault(_scrollAnimation);

var _viewportEmitter = __webpack_require__(21);

var _viewportEmitter2 = _interopRequireDefault(_viewportEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollAnimationComponent = function (_BaseComponent) {
  _inherits(ScrollAnimationComponent, _BaseComponent);

  function ScrollAnimationComponent(section, element, componentName, breakpoint, scrollPosition, windowHeight, index) {
    _classCallCheck(this, ScrollAnimationComponent);

    var _this = _possibleConstructorReturn(this, (ScrollAnimationComponent.__proto__ || Object.getPrototypeOf(ScrollAnimationComponent)).apply(this, arguments));

    _this.animationDefinitions = {};
    if (element.dataset.scrollAnimations) {
      try {
        _this.animationDefinitions = JSON.parse(element.dataset.scrollAnimations);
      } catch (err) {
        throw new Error('ScrollAnimationComponent invalid scroll animations data ' + element.dataset.scrollAnimations + '!');
      }
    }
    _this.section = section;
    _this.element = element;
    _this.breakpointName = breakpoint;
    _this.scrollAnimationItems = [];
    _this.rafWhenVisible = true;
    _this._memoizeMetrics(windowHeight);
    _this._initialize();
    return _this;
  }

  _createClass(ScrollAnimationComponent, [{
    key: '_initialize',
    value: function _initialize() {
      if (!this.breakpointName) {
        return;
      }
      var elements = this.element.querySelectorAll('[data-scroll-animation]:not(.scroll-animation-initialized)');
      var data;
      for (var i = 0, l = elements.length; i < l; i++) {
        var element = elements[i];
        if (!element.offsetHeight) {
          continue;
        }
        data = JSON.parse(element.dataset.scrollAnimation) || {};
        data.overrideScroll = true;
        data.overrideResize = true;
        data = this._formatOptions(data, this.breakpointName);
        this._setDefaultFriction(element, data);
        this.scrollAnimationItems.push(new _scrollAnimation2.default(element, data));
      }
    }
  }, {
    key: '_memoizeMetrics',
    value: function _memoizeMetrics(height) {
      this.windowHeight = height;
    }
  }, {
    key: '_formatOptions',
    value: function _formatOptions(data, currentBreakpoint) {
      var breakpoints = _viewportEmitter2.default.getBreakpoints();
      var out = {};
      // inherit unprefixed values
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (breakpoints.indexOf(key) > -1) {
            continue;
          }
          out[key] = value;
        }
        // get values for current breakpoint
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var breakpointData = data[currentBreakpoint];
      if (breakpointData) {
        if (typeof breakpointData === 'string') {
          var animationDefinition = this.animationDefinitions[breakpointData];
          if (!animationDefinition) {
            console.log('ScrollAnimationComponent non-existent animation \'' + breakpointData + '\'');
          } else {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = Object.entries(animationDefinition)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _ref3 = _step2.value;

                var _ref4 = _slicedToArray(_ref3, 2);

                var _key = _ref4[0];
                var _value = _ref4[1];

                out[_key] = _value;
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } else {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = Object.entries(breakpointData)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _ref5 = _step3.value;

              var _ref6 = _slicedToArray(_ref5, 2);

              var _key2 = _ref6[0];
              var _value2 = _ref6[1];

              out[_key2] = _value2;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      }
      return out;
    }
  }, {
    key: '_setDefaultFriction',
    value: function _setDefaultFriction(element, data) {
      data.friction = data.friction || 10;
    }
  }, {
    key: '_reInitialize',
    value: function _reInitialize() {
      this._destroyScrollAnimations();
      this._initialize();
      this.setupEvents();
    }
  }, {
    key: '_destroyScrollAnimations',
    value: function _destroyScrollAnimations() {
      for (var i = 0, l = this.scrollAnimationItems.length; i < l; i++) {
        this.scrollAnimationItems[i].destroy();
        this.scrollAnimationItems[i] = null;
      }
      this.scrollAnimationItems.length = 0;
    }
  }, {
    key: '_handleScroll',
    value: function _handleScroll(scrollPosition) {
      for (var i = 0, l = this.scrollAnimationItems.length; i < l; i++) {
        this.scrollAnimationItems[i].handleScroll(scrollPosition);
      }
    }
  }, {
    key: 'onScroll',
    value: function onScroll(event, scrollPosition, windowHeight) {
      _get(ScrollAnimationComponent.prototype.__proto__ || Object.getPrototypeOf(ScrollAnimationComponent.prototype), 'onScroll', this).call(this, event, scrollPosition, windowHeight);
      this._handleScroll(scrollPosition);
    }
  }, {
    key: 'onResizeImmediate',
    value: function onResizeImmediate(event, scrollPosition, windowHeight) {
      this._handleResizeImmediate(event, scrollPosition, windowHeight);
    }
  }, {
    key: 'onOrientationChange',
    value: function onOrientationChange(event, orientation, scrollPosition, windowHeight) {
      this._handleResizeImmediate(event, scrollPosition, windowHeight);
    }
  }, {
    key: '_handleResizeImmediate',
    value: function _handleResizeImmediate(event, scrollPosition, windowHeight) {
      this._memoizeMetrics(windowHeight);
      this._initialize(); // Initialize all elements that aren't yet
      for (var i = 0, l = this.scrollAnimationItems.length; i < l; i++) {
        var item = this.scrollAnimationItems[i];
        item.handleResize(scrollPosition);
      }
    }
  }, {
    key: 'onBreakpoint',
    value: function onBreakpoint(to, from, scrollPosition, windowHeight) {
      this.breakpointName = to;
      this._reInitialize();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._destroyScrollAnimations();
      _get(ScrollAnimationComponent.prototype.__proto__ || Object.getPrototypeOf(ScrollAnimationComponent.prototype), 'destroy', this).call(this);
    }
  }]);

  return ScrollAnimationComponent;
}(_baseComponent2.default);

exports.default = ScrollAnimationComponent;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _elementTracker = __webpack_require__(77);

var _elementTracker2 = _interopRequireDefault(_elementTracker);

var _object = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultOptions = {
  timeToEngage: 500,
  inViewThreshold: 0.75,
  stopOnEngaged: true
};

var overrideOptions = {
  thresholdEnterTime: 0,
  thresholdExitTime: 0,
  inThreshold: false,
  engaged: false,
  tracking: true
};

var ElementEngagement = function (_ElementTracker) {
  _inherits(ElementEngagement, _ElementTracker);

  function ElementEngagement() {
    _classCallCheck(this, ElementEngagement);

    var _this = _possibleConstructorReturn(this, (ElementEngagement.__proto__ || Object.getPrototypeOf(ElementEngagement)).call(this));

    _this._thresholdEnter = _this._thresholdEnter.bind(_this);
    _this._thresholdExit = _this._thresholdExit.bind(_this);
    _this._enterView = _this._enterView.bind(_this);
    _this._exitView = _this._exitView.bind(_this);
    return _this;
  }

  _createClass(ElementEngagement, [{
    key: '_decorateTrackedElement',
    value: function _decorateTrackedElement(trackedElement, options) {
      var optionsWithDefaults = (0, _object.defaults)(defaultOptions, options || {});
      (0, _object.extend)(trackedElement, optionsWithDefaults);
      (0, _object.extend)(trackedElement, overrideOptions);
    }
  }, {
    key: '_attachElementListeners',
    value: function _attachElementListeners(trackedElement) {
      trackedElement.on('thresholdenter', this._thresholdEnter, this);
      trackedElement.on('thresholdexit', this._thresholdExit, this);
      trackedElement.on('enterview', this._enterView, this);
      trackedElement.on('exitview', this._exitView, this);
    }
  }, {
    key: '_removeElementListeners',
    value: function _removeElementListeners(trackedElement) {
      trackedElement.off('thresholdenter', this._thresholdEnter);
      trackedElement.off('thresholdexit', this._thresholdExit);
      trackedElement.off('enterview', this._enterView);
      trackedElement.off('exitview', this._exitView);
    }
  }, {
    key: '_attachAllElementListeners',
    value: function _attachAllElementListeners() {
      var _this2 = this;

      this.elements.forEach(function (trackedElement) {
        if (!trackedElement.stopOnEngaged) {
          _this2._attachElementListeners(trackedElement);
        } else {
          if (!trackedElement.engaged) {
            _this2._attachElementListeners(trackedElement);
          }
        }
      });
    }
  }, {
    key: '_removeAllElementListeners',
    value: function _removeAllElementListeners() {
      var _this3 = this;

      this.elements.forEach(function (trackedElement) {
        _this3._removeElementListeners(trackedElement);
      });
    }
  }, {
    key: '_elementInViewPastThreshold',
    value: function _elementInViewPastThreshold(trackedElement) {
      var clientHeight = window.innerHeight || document.documentElement.clientHeight;
      var inViewPastThreshold = false;
      if (trackedElement.pixelsInView === clientHeight) {
        inViewPastThreshold = true;
      } else {
        inViewPastThreshold = trackedElement.percentInView > trackedElement.inViewThreshold;
      }
      return inViewPastThreshold;
    }
  }, {
    key: '_ifInView',
    value: function _ifInView(trackedElement, alreadyInView) {
      var inThreshold = trackedElement.inThreshold;
      _get(ElementEngagement.prototype.__proto__ || Object.getPrototypeOf(ElementEngagement.prototype), '_ifInView', this).apply(this, arguments);
      if (!inThreshold && this._elementInViewPastThreshold(trackedElement)) {
        trackedElement.inThreshold = true;
        trackedElement.trigger('thresholdenter', trackedElement);
        if (typeof trackedElement.timeToEngage === 'number' && trackedElement.timeToEngage >= 0) {
          trackedElement.engagedTimeout = window.setTimeout(this._engaged.bind(this, trackedElement), trackedElement.timeToEngage);
        }
      }
    }
  }, {
    key: '_ifAlreadyInView',
    value: function _ifAlreadyInView(trackedElement) {
      var inThreshold = trackedElement.inThreshold;
      _get(ElementEngagement.prototype.__proto__ || Object.getPrototypeOf(ElementEngagement.prototype), '_ifAlreadyInView', this).apply(this, arguments);
      if (inThreshold && !this._elementInViewPastThreshold(trackedElement)) {
        trackedElement.inThreshold = false;
        trackedElement.trigger('thresholdexit', trackedElement);
        if (trackedElement.engagedTimeout) {
          window.clearTimeout(trackedElement.engagedTimeout);
          trackedElement.engagedTimeout = null;
        }
      }
    }
  }, {
    key: '_engaged',
    value: function _engaged(trackedElement) {
      trackedElement.engagedTimeout = null;
      this._elementEngaged(trackedElement);
      trackedElement.trigger('engaged', trackedElement);
      this.trigger('engaged', trackedElement);
    }
  }, {
    key: '_thresholdEnter',
    value: function _thresholdEnter(trackedElement) {
      trackedElement.thresholdEnterTime = Date.now();
      trackedElement.thresholdExitTime = 0;
      this.trigger('thresholdenter', trackedElement);
    }
  }, {
    key: '_thresholdExit',
    value: function _thresholdExit(trackedElement) {
      trackedElement.thresholdExitTime = Date.now();
      this.trigger('thresholdexit', trackedElement);
    }
  }, {
    key: '_enterView',
    value: function _enterView(trackedElement) {
      this.trigger('enterview', trackedElement);
    }
  }, {
    key: '_exitView',
    value: function _exitView(trackedElement) {
      this.trigger('exitview', trackedElement);
    }
  }, {
    key: '_elementEngaged',
    value: function _elementEngaged(trackedElement) {
      trackedElement.engaged = true;
      if (trackedElement.stopOnEngaged) {
        this.stop(trackedElement);
      }
    }
  }, {
    key: 'stop',
    value: function stop(trackedElement) {
      if (this.tracking && !trackedElement) {
        this._removeAllElementListeners();
        _get(ElementEngagement.prototype.__proto__ || Object.getPrototypeOf(ElementEngagement.prototype), 'stop', this).call(this);
      }
      if (trackedElement && trackedElement.tracking) {
        trackedElement.tracking = false;
        this._removeElementListeners(trackedElement);
      }
    }
  }, {
    key: 'start',
    value: function start(trackedElement) {
      if (!trackedElement) {
        this._attachAllElementListeners();
      }
      if (trackedElement && !trackedElement.tracking) {
        if (!trackedElement.stopOnEngaged) {
          trackedElement.tracking = true;
          this._attachElementListeners(trackedElement);
        } else {
          if (!trackedElement.engaged) {
            trackedElement.tracking = true;
            this._attachElementListeners(trackedElement);
          }
        }
      }
      if (!this.tracking) {
        _get(ElementEngagement.prototype.__proto__ || Object.getPrototypeOf(ElementEngagement.prototype), 'start', this).call(this);
      } else {
        this.refreshAllElementMetrics();
        this.refreshAllElementStates();
      }
    }
  }, {
    key: 'addElement',
    value: function addElement(element, options) {
      var trackedElement = _get(ElementEngagement.prototype.__proto__ || Object.getPrototypeOf(ElementEngagement.prototype), 'addElement', this).call(this, element);
      this._decorateTrackedElement(trackedElement, options);
      return trackedElement;
    }
  }, {
    key: 'addElements',
    value: function addElements(elements, options) {
      var _this4 = this;

      [].forEach.call(elements, function (element) {
        _this4.addElement(element, options);
      });
    }
  }]);

  return ElementEngagement;
}(_elementTracker2.default);

exports.default = ElementEngagement;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = toArray;
function toArray(array) {
  return Array.prototype.slice.call(array);
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var transitionend = {
  'animation-delay': 'transitionend',
  '-o-animation-delay': 'oTransitionEnd',
  '-moz-animation-delay': 'transitionend',
  '-webkit-animation-delay': 'webkitTransitionEnd',
  '-ms-animation-delay': 'transitionend'
};
var animationstart = {
  'animation-delay': 'animationstart',
  '-o-animation-delay': 'oanimationstart',
  '-moz-animation-delay': 'animationstart',
  '-webkit-animation-delay': 'webkitAnimationStart',
  '-ms-animation-delay': 'MSAnimationStart'
};
var animationiteration = {
  'animation-delay': 'animationiteration',
  '-o-animation-delay': 'oanimationiteration',
  '-moz-animation-delay': 'animationiteration',
  '-webkit-animation-delay': 'webkitAnimationIteration',
  '-ms-animation-delay': 'MSAnimationIteration'
};
var animationend = {
  'animation-delay': 'animationend',
  '-o-animation-delay': 'oanimationend',
  '-moz-animation-delay': 'animationend',
  '-webkit-animation-delay': 'webkitAnimationEnd',
  '-ms-animation-delay': 'MSAnimationEnd'
};

var testEle = document.createElement('_');

var prefixes = ['', '-webkit-', '-moz-', '-o-', '-ms-'];
function prefix(property) {
  for (var i = 0; i < prefixes.length; i++) {
    var prefixed = prefixes[i] + property;
    if (testEle.style[prefixed] !== undefined) {
      return prefixed;
    }
  }
  return undefined;
}

var prefixesWebkit = ['-webkit-', '', '-moz-', '-o-', '-ms-'];
function prefixWebkit(property) {
  for (var i = 0; i < prefixesWebkit.length; i++) {
    var prefixed = prefixesWebkit[i] + property;
    if (testEle.style[prefixed] !== undefined) {
      return prefixed;
    }
  }
  return undefined;
}

var filter = exports.filter = prefixWebkit('filter');
var transform = exports.transform = prefix('transform');
var transformOrigin = exports.transformOrigin = prefix('transform-origin');
var transition = exports.transition = prefix('transition');
var transitionDelay = exports.transitionDelay = prefix('transition-delay');
var transitionDuration = exports.transitionDuration = prefix('transition-duration');
var transitionProperty = exports.transitionProperty = prefix('transition-property');
var transitionTimingFunction = exports.transitionTimingFunction = prefix('transition-timing-function');
var transitionEnd = exports.transitionEnd = transitionend[prefix('animation-delay')];
var animation = exports.animation = prefix('animation');
var animationDelay = exports.animationDelay = prefix('animation-delay');
var animationDirection = exports.animationDirection = prefix('animation-direction');
var animationDuration = exports.animationDuration = prefix('animation-duration');
var animationFillMode = exports.animationFillMode = prefix('animation-fill-mode');
var animationIterationCount = exports.animationIterationCount = prefix('animation-iteration-count');
var animationName = exports.animationName = prefix('animation-name');
var animationTimingFunction = exports.animationTimingFunction = prefix('animation-timing-function');
var animationPlayState = exports.animationPlayState = prefix('animation-play-state');
var animationStart = exports.animationStart = animationstart[prefix('animation-delay')];
var animationIteration = exports.animationIteration = animationiteration[prefix('animation-delay')];
var animationEnd = exports.animationEnd = animationend[prefix('animation-delay')];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isNodeType = isNodeType;
exports.isComment = isComment;
exports.isDocument = isDocument;
exports.isDocumentFragment = isDocumentFragment;
exports.isDocumentType = isDocumentType;
exports.isElement = isElement;
exports.isNode = isNode;
exports.isNodeList = isNodeList;
exports.isTextNode = isTextNode;
var COMMENT_NODE = exports.COMMENT_NODE = 8;
var DOCUMENT_FRAGMENT_NODE = exports.DOCUMENT_FRAGMENT_NODE = 11;
var DOCUMENT_NODE = exports.DOCUMENT_NODE = 9;
var DOCUMENT_TYPE_NODE = exports.DOCUMENT_TYPE_NODE = 10;
var ELEMENT_NODE = exports.ELEMENT_NODE = 1;
var TEXT_NODE = exports.TEXT_NODE = 3;

function isNodeType(node, types) {
  if (!isNode(node)) {
    return false;
  }
  if (typeof types === 'number') {
    return node.nodeType === types;
  }
  return types.indexOf(node.nodeType) !== -1;
}

function isComment(node) {
  return isNodeType(node, COMMENT_NODE);
}

function isDocument(node) {
  return isNodeType(node, DOCUMENT_NODE);
}

function isDocumentFragment(node) {
  return isNodeType(node, DOCUMENT_FRAGMENT_NODE);
}

function isDocumentType(node) {
  return isNodeType(node, DOCUMENT_TYPE_NODE);
}

function isElement(node) {
  return isNodeType(node, ELEMENT_NODE);
}

function isNode(node) {
  return !!(node && node.nodeType);
}

var isNodeRegex = /^\[object (HTMLCollection|NodeList|Object)\]$/;
function isNodeList(list) {
  if (!list) {
    return false;
  }
  if (typeof list.length !== 'number') {
    return false;
  }
  if (_typeof(list[0]) === 'object' && (!list[0] || !list[0].nodeType)) {
    return false;
  }
  return isNodeRegex.test(list.toString());
};

function isTextNode(node) {
  return isNodeType(node, TEXT_NODE);
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linearTween = linearTween;
exports.easeInQuad = easeInQuad;
exports.easeOutQuad = easeOutQuad;
exports.easeInOutQuad = easeInOutQuad;
exports.easeInCubic = easeInCubic;
exports.easeOutCubic = easeOutCubic;
exports.easeInOutCubic = easeInOutCubic;
exports.easeInQuart = easeInQuart;
exports.easeOutQuart = easeOutQuart;
exports.easeInOutQuart = easeInOutQuart;
exports.easeInQuint = easeInQuint;
exports.easeOutQuint = easeOutQuint;
exports.easeInOutQuint = easeInOutQuint;
exports.easeInSine = easeInSine;
exports.easeOutSine = easeOutSine;
exports.easeInOutSine = easeInOutSine;
exports.easeInExpo = easeInExpo;
exports.easeOutExpo = easeOutExpo;
exports.easeInOutExpo = easeInOutExpo;
exports.easeInCirc = easeInCirc;
exports.easeOutCirc = easeOutCirc;
exports.easeInOutCirc = easeInOutCirc;
// arguments:
// t = current time
// b = start value
// c = change in value
// d = duration

// simple linear tweening - no easing, no acceleration
function linearTween(t, b, c, d) {
  return c * t / d + b;
}

// quadratic easing in - accelerating from zero velocity
function easeInQuad(t, b, c, d) {
  t /= d;
  return c * t * t + b;
}

// quadratic easing out - decelerating to zero velocity
function easeOutQuad(t, b, c, d) {
  t /= d;
  return -c * t * (t - 2) + b;
}

// quadratic easing in/out - acceleration until halfway, then deceleration
function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
}

// cubic easing in - accelerating from zero velocity
function easeInCubic(t, b, c, d) {
  t /= d;
  return c * t * t * t + b;
}

// cubic easing out - decelerating to zero velocity
function easeOutCubic(t, b, c, d) {
  t /= d;
  t--;
  return c * (t * t * t + 1) + b;
}

// cubic easing in/out - acceleration until halfway, then deceleration
function easeInOutCubic(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t * t + b;
  t -= 2;
  return c / 2 * (t * t * t + 2) + b;
}

// quartic easing in - accelerating from zero velocity
function easeInQuart(t, b, c, d) {
  t /= d;
  return c * t * t * t * t + b;
}

// quartic easing out - decelerating to zero velocity
function easeOutQuart(t, b, c, d) {
  t /= d;
  t--;
  return -c * (t * t * t * t - 1) + b;
}

// quartic easing in/out - acceleration until halfway, then deceleration
function easeInOutQuart(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t * t * t + b;
  t -= 2;
  return -c / 2 * (t * t * t * t - 2) + b;
}

// quintic easing in - accelerating from zero velocity
function easeInQuint(t, b, c, d) {
  t /= d;
  return c * t * t * t * t * t + b;
}

// quintic easing out - decelerating to zero velocity
function easeOutQuint(t, b, c, d) {
  t /= d;
  t--;
  return c * (t * t * t * t * t + 1) + b;
}

// quintic easing in/out - acceleration until halfway, then deceleration
function easeInOutQuint(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t * t * t * t + b;
  t -= 2;
  return c / 2 * (t * t * t * t * t + 2) + b;
}

// sinusoidal easing in - accelerating from zero velocity
function easeInSine(t, b, c, d) {
  return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
}

// sinusoidal easing out - decelerating to zero velocity
function easeOutSine(t, b, c, d) {
  return c * Math.sin(t / d * (Math.PI / 2)) + b;
}

// sinusoidal easing in/out - accelerating until halfway, then decelerating
function easeInOutSine(t, b, c, d) {
  return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
}

// exponential easing in - accelerating from zero velocity
function easeInExpo(t, b, c, d) {
  return c * Math.pow(2, 10 * (t / d - 1)) + b;
}

// exponential easing out - decelerating to zero velocity
function easeOutExpo(t, b, c, d) {
  return c * (-Math.pow(2, -10 * t / d) + 1) + b;
}

// exponential easing in/out - accelerating until halfway, then decelerating
function easeInOutExpo(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
  t--;
  return c / 2 * (-Math.pow(2, -10 * t) + 2) + b;
}

// circular easing in - accelerating from zero velocity
function easeInCirc(t, b, c, d) {
  t /= d;
  return -c * (Math.sqrt(1 - t * t) - 1) + b;
}

// circular easing out - decelerating to zero velocity
function easeOutCirc(t, b, c, d) {
  t /= d;
  t--;
  return c * Math.sqrt(1 - t * t) + b;
}

// circular easing in/out - acceleration until halfway, then deceleration
function easeInOutCirc(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
  t -= 2;
  return c / 2 * (Math.sqrt(1 - t * t) + 1) + b;
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lerp = lerp;
exports.map = map;
exports.norm = norm;
exports.clamp = clamp;
exports.randFloat = randFloat;
exports.randInt = randInt;
function lerp(ratio, start, end) {
  return start + (end - start) * ratio;
}

function map(val, min1, max1, min2, max2) {
  return this.lerp(this.norm(val, min1, max1), min2, max2);
}

function norm(val, min, max) {
  return (val - min) / (max - min);
}

function clamp(val, min, max) {
  return Math.max(min, Math.min(max, val));
}

function randFloat(min, max) {
  return Math.random() * (max - min) + min;
}

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

var _clock = __webpack_require__(219);

var _clock2 = _interopRequireDefault(_clock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MotionEmitter = function (_EventEmitterMicro) {
  _inherits(MotionEmitter, _EventEmitterMicro);

  function MotionEmitter(options) {
    _classCallCheck(this, MotionEmitter);

    var _this = _possibleConstructorReturn(this, (MotionEmitter.__proto__ || Object.getPrototypeOf(MotionEmitter)).call(this));

    _this.options = options || {};
    _this.min = _this.options.min || 0;
    _this.max = _this.options.max || 1;
    _this._boundHandleClockUpdate = _this._handleClockUpdate.bind(_this);
    _this._boundHandleClockDraw = _this._handleClockDraw.bind(_this);
    if (_this.options.easingFunction) {
      _this.easingFunction = _this.options.easingFunction;
    }
    _this.clock = _this.options.clock || _clock2.default;
    _this.usesSharedClock = _this.clock === _clock2.default;
    _this._isRunning = false;
    _this.specificity = _this.options.specificity || 4;
    _this.friction = _this.options.friction || 10;
    _this._targetValue = null;
    _this._currentValue = null;
    _this._shouldUpdate = false;
    _this._shouldEmitChange = false;
    return _this;
  }

  _createClass(MotionEmitter, [{
    key: 'destroy',
    value: function destroy() {
      this.trigger('destroy');
      this.stop();
      this.off();
      if (!this.usesSharedClock) {
        this.clock.destroy();
      }
      for (var prop in this) {
        if (this.hasOwnProperty(prop)) {
          this[prop] = null;
        }
      }
      this._isRunning = false;
    }
  }, {
    key: 'start',
    value: function start() {
      if (!this.clock || this._isRunning) {
        return;
      }
      this._bindEvents();
      this._isRunning = true;
      this.clock.start();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!this.clock || !this._isRunning) {
        return;
      }
      this._unbindEvents();
      this._isRunning = false;
      if (!this.usesSharedClock) {
        this.clock.stop();
      }
    }
  }, {
    key: 'isRunning',
    value: function isRunning() {
      return this._isRunning;
    }
  }, {
    key: 'setProgress',
    value: function setProgress(value) {
      if (this._targetValue === value) {
        return;
      }
      this._targetValue = value;
      this._shouldUpdate = true;
    }
  }, {
    key: 'updateValue',
    value: function updateValue(event) {
      if (this._currentValue === null) {
        this._currentValue = this._targetValue;
      }
      var f = 1;
      if (this.easingFunction) {
        var w = this.max - this.min;
        var v = this.max - (this.max - this._targetValue) / w;
        var c = this.max - (this.max - this._currentValue) / w;
        var u = 1 - Math.abs(v - c);
        var b = this.easingFunction(u, 0, 1, 1);
        f = 1 + (b - u);
      }
      var a = 1;
      if (event && event.naturalFps !== event.fps) {
        a = event.naturalFps / event.fps;
      }
      var i = this._targetValue - this._currentValue;
      var h = i * f * a * (1 / this.friction);
      var g = parseFloat((this._currentValue + h).toFixed(this.specificity));
      if (g === this._currentValue) {
        this._currentValue = this._targetValue;
      } else {
        this._currentValue = g;
      }
      this._shouldEmitChange = true;
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this.clock.on('update', this._boundHandleClockUpdate);
      this.clock.on('draw', this._boundHandleClockDraw);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.clock.off('update', this._boundHandleClockUpdate);
      this.clock.off('draw', this._boundHandleClockDraw);
    }
  }, {
    key: '_handleClockUpdate',
    value: function _handleClockUpdate(event) {
      if (this._shouldUpdate) {
        this.updateValue(event);
      }
      if (!this._shouldEmitChange) {
        return;
      }
      event.progress = this._currentValue;
      this.trigger('update', event);
    }
  }, {
    key: '_handleClockDraw',
    value: function _handleClockDraw(event) {
      if (!this._shouldEmitChange) {
        return;
      }
      event.progress = this._currentValue;
      this.trigger('draw', event);
      if (this._targetValue === this._currentValue) {
        this._shouldUpdate = false;
        this._shouldEmitChange = false;
        return;
      }
      this._shouldUpdate = true;
    }
  }]);

  return MotionEmitter;
}(_eventEmitterMicro2.default);

exports.default = MotionEmitter;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _components = __webpack_require__(221);

var componentMap = _interopRequireWildcard(_components);

var _viewportEmitter = __webpack_require__(21);

var _viewportEmitter2 = _interopRequireDefault(_viewportEmitter);

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

var _elementTracker = __webpack_require__(77);

var _elementTracker2 = _interopRequireDefault(_elementTracker);

var _elementEngagement = __webpack_require__(223);

var _elementEngagement2 = _interopRequireDefault(_elementEngagement);

var _domMetrics = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Section = function (_EventEmitterMicro) {
  _inherits(Section, _EventEmitterMicro);

  function Section(layout, trackedElement, currentBreakpoint, scrollPosition, windowHeight, index) {
    _classCallCheck(this, Section);

    if (arguments.length !== 6) {
      throw new Error('Incorrect number of arguments passed to Section');
    }

    var _this = _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).call(this));

    _this.element = layout;
    _this.trackedElement = trackedElement;
    _this.elementEngagement = new _elementEngagement2.default(null, {
      autoStart: false
    });

    _this.rafWhenVisible = _this.rafWhenVisible || false;
    _this.index = index;
    _this.isVisible = _this.trackedElement.pixelsInView > 0;
    _this.hasAnimatedIn = false;
    _this.isActive = false;
    _this.cachedBreakpoint = currentBreakpoint;
    _this.cachedScrollPosition = scrollPosition;
    _this.cachedWindowHeight = windowHeight;
    _this.scrollToPosition = 0;
    _this.updateScrollToPosition();
    _this._components = [];
    _this.setupComponents(currentBreakpoint, scrollPosition, windowHeight);
    return _this;
  }

  _createClass(Section, [{
    key: 'setupComponents',
    value: function setupComponents() {
      var componentElements = this.element.querySelectorAll('[data-components]');
      componentElements = Array.apply(undefined, _toConsumableArray(componentElements));
      if (this.element.hasAttribute('data-components')) {
        componentElements.push(this.element);
      }
      for (var f = 0; f < componentElements.length; f++) {
        var componentElement = componentElements[f];
        var componentList = componentElement.dataset.components;
        componentList = componentList.split(' ');
        for (var i = 0, l = componentList.length; i < l; i++) {
          var component = componentList[i];
          if (component === '' || component === ' ') {
            continue;
          }
          this.addComponentOfType(component, componentElement);
        }
        setTimeout(this.elementEngagement.refreshAllElementStates.bind(this.elementEngagement), 100);
      }
    }
  }, {
    key: 'addComponentOfType',
    value: function addComponentOfType(componentName, element) {
      if (!componentMap.hasOwnProperty(componentName)) {
        throw new Error('Section::setupComponents parsing \'#' + element.id + '.' + element.className + '\' no component type \'' + componentName + '\' found!');
      }
      var ComponentClass = componentMap[componentName];
      if (!this.componentIsSupported(ComponentClass, componentName)) {
        console.log('Section::setupComponents unsupported component \'' + componentName + '\'. Reason: \'' + componentName + '.IS_SUPPORTED\' returned false');
        return;
      }
      var component = new ComponentClass(this, element, componentName, this.cachedBreakpoint, this.cachedScrollPosition, this.cachedWindowHeight, this._components.length);
      this.rafWhenVisible = component.rafWhenVisible || this.rafWhenVisible;
      this._components.push(component);
    }
  }, {
    key: 'componentIsSupported',
    value: function componentIsSupported(component, componentName) {
      var isSupported = component.IS_SUPPORTED;
      if (isSupported === undefined || typeof isSupported !== 'function') {
        return true;
      }
      return component.IS_SUPPORTED() === true;
    }
  }, {
    key: 'updateScrollToPosition',
    value: function updateScrollToPosition() {
      return this.scrollToPosition = (0, _domMetrics.getPagePosition)(this.element).top;
    }
  }, {
    key: 'setupEvents',
    value: function setupEvents() {
      for (var i = 0, l = this._components.length; i < l; i++) {
        this._components[i].setupEvents();
      }
    }
  }, {
    key: 'teardownEvents',
    value: function teardownEvents() {
      for (var i = 0, l = this._components.length; i < l; i++) {
        this._components[i].teardownEvents();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.teardownEvents();
      this.elementEngagement.stop();
      this.elementEngagement = null;
      for (var i = 0, l = this._components.length; i < l; i++) {
        this._components[i].destroy();
      }
      this._components = null;
      this.trackedElement = null;
      this.element = null;
      _get(Section.prototype.__proto__ || Object.getPrototypeOf(Section.prototype), 'destroy', this).call(this);
    }
  }, {
    key: 'activate',
    value: function activate() {
      this.element.classList.add('active');
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].activate();
      }
      this.isActive = true;
      if (!this.hasAnimatedIn) {
        this.element.classList.add('animated');
        this.animateIn();
        this.hasAnimatedIn = true;
      }
    }
  }, {
    key: 'deactivate',
    value: function deactivate() {
      this.element.classList.remove('active');
      this.isActive = false;
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].deactivate();
      }
    }
  }, {
    key: 'animateIn',
    value: function animateIn() {
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].animateIn();
      }
    }
  }, {
    key: 'onRequestAnimationFrame',
    value: function onRequestAnimationFrame() {
      for (var i = 0, l = this._components.length; i < l; i++) {
        var component = this._components[i];
        if (!component.isEnabled) {
          continue;
        }
        if (component.rafWhenVisible || this.isActive) {
          component.onRequestAnimationFrame();
        }
      }
    }
  }, {
    key: 'onResizeImmediate',
    value: function onResizeImmediate(event, scrollPosition, windowHeight) {
      this.cachedScrollPosition = scrollPosition;
      this.cachedWindowHeight = windowHeight;
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].onResizeImmediate(event, scrollPosition, windowHeight);
      }
    }
  }, {
    key: 'onOrientationChange',
    value: function onOrientationChange(event, orientation, scrollPosition, windowHeight) {
      this.cachedScrollPosition = scrollPosition;
      this.cachedWindowHeight = windowHeight;
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].onOrientationChange(event, orientation, scrollPosition, windowHeight);
      }
    }
  }, {
    key: 'onResizeDebounced',
    value: function onResizeDebounced(event, scrollPosition, windowHeight) {
      this.updateScrollToPosition();
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].onResizeDebounced(event, scrollPosition, windowHeight);
      }
      this.elementEngagement.refreshAllElementMetrics();
    }
  }, {
    key: 'onScroll',
    value: function onScroll(event, scrollPosition, windowHeight) {
      this.cachedScrollPosition = scrollPosition;
      this.elementEngagement.refreshAllElementStates();
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].onScroll(event, scrollPosition, windowHeight);
      }
    }
  }, {
    key: 'onSectionWillAppear',
    value: function onSectionWillAppear(scrollPosition, windowHeight) {
      this.cachedScrollPosition = scrollPosition;
      this.isVisible = true;
      this.elementEngagement.refreshAllElementStates();
      for (var i = 0, l = this._components.length; i < l; i++) {
        this._components[i].onSectionWillAppear(scrollPosition, windowHeight);
      }
    }
  }, {
    key: 'onSectionWillDisappear',
    value: function onSectionWillDisappear(scrollPosition, windowHeight) {
      this.cachedScrollPosition = scrollPosition;
      this.isVisible = false;
      for (var i = 0, l = this._components.length; i < l; i++) {
        this._components[i].onSectionWillDisappear(scrollPosition, windowHeight);
      }
    }
  }, {
    key: 'onBreakpoint',
    value: function onBreakpoint(to, from, scrollPosition, windowHeight) {
      this.cachedBreakpoint = to;
      for (var i = 0, l = this._components.length; i < l; i++) {
        if (!this._components[i].isEnabled) {
          continue;
        }
        this._components[i].onBreakpoint(to, from, scrollPosition, windowHeight);
      }
      this.elementEngagement.refreshAllElementMetrics();
    }
  }]);

  return Section;
}(_eventEmitterMicro2.default);

var Page = function () {
  function Page() {
    _classCallCheck(this, Page);

    this._sections = [];
    this._visibleSections = [];
    this._elementTracker = new _elementTracker2.default(null, {
      autoStart: true
    });
    this._currentSection = null;
    this._currentBreakpoint = _viewportEmitter2.default.breakpoint;
    this._cachedScrollY = this._getScrollY(true);
    this._cachedWindowHeight = this._getWindowHeight(true);
    this._rafId = -1;
    this._resizeTimeout = -1;
    this._resizeTimeoutDelay = this._resizeTimeoutDelay || 250;
    this.setupEvents();
    this._updateSectionVisibility(this._getScrollY(), this._getWindowHeight());
    this._onRequestAnimationFrame();
  }

  _createClass(Page, [{
    key: 'destroy',
    value: function destroy() {
      for (var a = 0, b = this._sections.length; a < b; a++) {
        this._sections[a].destroy();
      }
      this.teardownEvents();
      this._elementTracker.destroy();
      this._elementTracker = null;
      this._sections = null;
      this._currentSection = null;
      this._visibleSections = null;
    }
  }, {
    key: 'setupEvents',
    value: function setupEvents() {
      this._onScroll = this._onScroll.bind(this);
      this._onBreakpoint = this._onBreakpoint.bind(this);
      this._onPageDidAppear = this._onPageDidAppear.bind(this);
      this._onResizeImmediate = this._onResizeImmediate.bind(this);
      this._onOrientationChange = this._onOrientationChange.bind(this);
      this._onPageWillDisappear = this._onPageWillDisappear.bind(this);
      this._onRequestAnimationFrame = this._onRequestAnimationFrame.bind(this);
      this.performDeepMetricsRefresh = this.performDeepMetricsRefresh.bind(this);
      _viewportEmitter2.default.on('scroll', this._onScroll);
      _viewportEmitter2.default.on('resize', this._onResizeImmediate);
      _viewportEmitter2.default.on('orientationchange', this._onOrientationChange);
      _viewportEmitter2.default.on('breakpoint', this._onBreakpoint);
      // TODO
      // Page.on(Page.DEEP_REFRESH_ALL_METRICS, this.performDeepMetricsRefresh)
    }
  }, {
    key: 'teardownEvents',
    value: function teardownEvents() {
      _viewportEmitter2.default.off('scroll', this._onScroll);
      _viewportEmitter2.default.off('resize', this._onResizeImmediate);
      _viewportEmitter2.default.off('orientationchange', this._onOrientationChange);
      _viewportEmitter2.default.off('breakpoint', this._onBreakpoint);
      // TODO
      // Page.off(Page.DEEP_REFRESH_ALL_METRICS, this.performDeepMetricsRefresh);
      this._elementTracker.stop();
      window.clearTimeout(this._resizeTimeout);
      window.cancelAnimationFrame(this._rafId);
    }
  }, {
    key: 'addSection',
    value: function addSection(layout) {
      for (var i = 0, l = this._sections.length; i < l; i++) {
        if (this._sections[i].element === layout) {
          throw new Error('Page::addSection tried to add a section that is already present');
        }
      }
      var scrollPosition = this._getScrollY();
      var currentBreakpoint = this._getCurrentBreakpoint();
      var windowHeight = this._getWindowHeight();

      var trackedElement = this._elementTracker.addElement(layout);
      this._elementTracker.refreshElementState(trackedElement);
      var section = new Section(layout, trackedElement, currentBreakpoint, scrollPosition, windowHeight, this._sections.length);
      section.setupEvents();
      this._sections.push(section);

      this._updateSectionVisibility(scrollPosition, windowHeight);
      this._onRequestAnimationFrame();
    }
  }, {
    key: '_activateSection',
    value: function _activateSection(section) {
      if (this._currentSection === section) {
        return;
      }
      if (this._currentSection) {
        this._currentSection.deactivate();
      }
      this._currentSection = section;
      if (section) {
        this._currentSection.activate();
      }
    }
  }, {
    key: '_updateSectionVisibility',
    value: function _updateSectionVisibility(scrollPosition, windowHeight) {
      var currentSection = this._sections[0];
      var visibleSections = [];
      var highestPixelCount = 0;
      for (var i = 0, l = this._sections.length; i < l; i++) {
        var section = this._sections[i];
        var pixelsInView = section.trackedElement.pixelsInView;
        if (pixelsInView > highestPixelCount) {
          currentSection = section;
          highestPixelCount = pixelsInView;
        }
        if (pixelsInView > 0.000001) {
          visibleSections.push(section);
        }
      }
      for (var _i = 0, _l = Math.max(this._visibleSections.length, visibleSections.length); _i < _l; _i++) {
        if (this._visibleSections[_i] && visibleSections.indexOf(this._visibleSections[_i]) === -1) {
          this._visibleSections[_i].onSectionWillDisappear(scrollPosition, windowHeight);
        }
        if (visibleSections[_i] && this._visibleSections.indexOf(visibleSections[_i]) === -1) {
          visibleSections[_i].onSectionWillAppear(scrollPosition, windowHeight);
        }
      }
      this._visibleSections = visibleSections;
      this._activateSection(currentSection);
    }
  }, {
    key: '_onPageDidAppear',
    value: function _onPageDidAppear(event) {}
  }, {
    key: '_onPageWillDisappear',
    value: function _onPageWillDisappear(event) {
      this.destroy();
    }
  }, {
    key: '_onBreakpoint',
    value: function _onBreakpoint(event) {
      var to = event.to;
      var from = event.from;
      this._currentBreakpoint = to;
      var scrollPosition = this._getScrollY();
      var windowHeight = this._getWindowHeight();
      this._elementTracker.refreshAllElementMetrics();
      for (var i = 0, l = this._sections.length; i < l; i++) {
        this._sections[i].onBreakpoint(to, from, scrollPosition, windowHeight);
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      var scrollPosition = this._getScrollY(true);
      var windowHeight = this._getWindowHeight();
      this._updateSectionVisibility(scrollPosition, windowHeight);
      for (var i = 0, l = this._visibleSections.length; i < l; i++) {
        this._visibleSections[i].onScroll(event, scrollPosition, windowHeight);
      }
    }
  }, {
    key: '_onResizeDebounced',
    value: function _onResizeDebounced(event) {
      var scrollPosition = this._getScrollY();
      var windowHeight = this._getWindowHeight();
      for (var i = 0, l = this._sections.length; i < l; i++) {
        this._sections[i].onResizeDebounced(event, scrollPosition, windowHeight);
      }
      this._updateSectionVisibility(scrollPosition, windowHeight);
    }
  }, {
    key: 'performDeepMetricsRefresh',
    value: function performDeepMetricsRefresh() {
      this._elementTracker.refreshAllElementMetrics();
      for (var i = 0, l = this._sections.length; i < l; i++) {
        this._sections[i].elementEngagement.refreshAllElementMetrics();
        this._sections[i].updateScrollToPosition();
      }
      this._updateSectionVisibility(this._getScrollY(), this._getWindowHeight());
    }
  }, {
    key: '_onOrientationChange',
    value: function _onOrientationChange(event) {
      var scrollPosition = this._getScrollY(true);
      var windowHeight = this._getWindowHeight(true);
      var orientation = event.orientation;
      for (var i = 0, l = this._sections.length; i < l; i++) {
        this._sections[i].onOrientationChange(event, orientation, scrollPosition, windowHeight);
      }
    }
  }, {
    key: '_onResizeImmediate',
    value: function _onResizeImmediate(event) {
      var scrollPosition = this._getScrollY();
      var windowHeight = this._getWindowHeight(true);
      for (var i = 0, l = this._sections.length; i < l; i++) {
        this._sections[i].onResizeImmediate(event, scrollPosition, windowHeight);
      }
      window.clearTimeout(this._resizeTimeout);
      this._resizeTimeout = window.setTimeout(this._onResizeDebounced.bind(this, event), this._resizeTimeoutDelay);
    }
  }, {
    key: '_onRequestAnimationFrame',
    value: function _onRequestAnimationFrame() {
      this._rafId = window.requestAnimationFrame(this._onRequestAnimationFrame);
      for (var i = 0, l = this._visibleSections.length; i < l; i++) {
        var sections = this._visibleSections[i];
        if (sections.rafWhenVisible || sections.isActive) {
          sections.onRequestAnimationFrame();
        }
      }
    }
  }, {
    key: '_getScrollY',
    value: function _getScrollY(update) {
      if (update) {
        this._cachedScrollY = window.pageYOffset || (document.documentElement || document.body).scrollTop;
      }
      return this._cachedScrollY;
    }
  }, {
    key: '_getWindowHeight',
    value: function _getWindowHeight(update) {
      if (update) {
        this._cachedWindowHeight = document.documentElement.clientHeight || window.innerHeight;
      }
      return this._cachedWindowHeight;
    }
  }, {
    key: '_getVisibleBottomOfPage',
    value: function _getVisibleBottomOfPage() {
      return this._getScrollY() + this._getWindowHeight();
    }
  }, {
    key: '_getCurrentBreakpoint',
    value: function _getCurrentBreakpoint() {
      return this._currentBreakpoint;
    }
  }]);

  return Page;
}();

exports.default = Page;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _object = __webpack_require__(56);

var _domMetrics = __webpack_require__(38);

var _viewportEmitter = __webpack_require__(21);

var _viewportEmitter2 = _interopRequireDefault(_viewportEmitter);

var _mathUtils = __webpack_require__(228);

var _browserPrefixed = __webpack_require__(225);

var _scrollMotionEmitter = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultOptions = {
  duration: [0.5, 0.5, 0], // [viewport%, element%, pixel modifier]
  delay: [1.0, 0.0, 0], // [viewport%, element%, pixel modifier]
  friction: 4,
  translate: { 0.0: [0, 0] },
  scale: { 0.0: [1, 1] },
  rotate: { 0.0: 0 },
  fade: { 0.0: 1 },
  clipPath: { 0.0: [0, 0, 0, 0] },
  clipPathColor: '#fff',
  overrideScroll: false,
  overrideResize: false,
  elementScroll: false,
  smooth: true,
  scrollMotionEmitter: null
};
var transforms = ['translate', 'scale', 'rotate'];

// All browsers that support clip-path also support window.CSS.supports!
var canUseClipPath = window.CSS && window.CSS.supports('clip-path', 'inset(1px)');

var ScrollAnimation = function () {
  function ScrollAnimation(element, options) {
    _classCallCheck(this, ScrollAnimation);

    this.el = element;
    this.options = this._overrideDefaultOptions(options);
    this.transforms = {};
    this._update = this._update.bind(this);
    this._memoizeMetrics();
    this._setEmitterBounds();
    this._setupClipPath();
    this._initScrollMotionEmitter();
    this._setupEvents();
    this._isAnimating = false;
    this.el.classList.add('scroll-animation-initialized');
    this.handleScroll(_viewportEmitter2.default.scrollY());
  }

  _createClass(ScrollAnimation, [{
    key: 'destroy',
    value: function destroy() {
      this.el.classList.remove('scroll-animation-initialized');
      this._teardownEvents();
      this.scrollMotionEmitter.destroy();
      this.scrollMotionEmitter = null;
      if (this.hasTransform) {
        this.el.style[_browserPrefixed.transform] = this.initialTransform;
      }
      if (this.hasClipPath) {
        this.el.style.clipPath = this.initialClipPath;
        if (this.clipElements) {
          for (var i = 0, l = 4; i < l; i++) {
            var ele = this.clipElements[i];
            if (ele) {
              ele.parentElement.removeChild(ele);
            }
          }
        }
      }
      if (this.hasOpacity) {
        this.el.style.opacity = this.initialOpacity;
      }
      this.el = null;
      this.options = null;
    }
  }, {
    key: 'setOption',
    value: function setOption(option, value) {
      this.options[option] = value;
      if (option === 'duration' || option === 'delay') {
        this._setEmitterBounds();
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(scrollPosition) {
      this.scrollMotionEmitter.handleScroll(scrollPosition);
    }
  }, {
    key: 'handleResize',
    value: function handleResize(scrollPosition) {
      this._memoizeMetrics();
      this._setEmitterBounds();
      if (this.options.elementScroll) {
        this.scrollMotionEmitter.handleResize();
      }
      this.handleScroll(scrollPosition);
    }
  }, {
    key: 'getTransform',
    value: function getTransform(transform) {
      return this.transforms[transform];
    }
  }, {
    key: 'getOpacity',
    value: function getOpacity() {
      return this.opacity;
    }
  }, {
    key: '_overrideDefaultOptions',
    value: function _overrideDefaultOptions(options) {
      var outOptions = Object.assign((0, _object.clone)(defaultOptions), options);
      var option;
      for (option in options) {
        if (transforms.indexOf(option) > -1) {
          this.hasTransform = true;
          this.initialTransform = this.el.style[_browserPrefixed.transform] || null;
        } else if (option === 'fade') {
          this.hasOpacity = true;
          this.initialOpacity = this.el.style.opacity || null;
        } else if (option === 'clipPath') {
          this.hasClipPath = true;
          this.initialClipPath = this.el.style.clipPath || null;
        }
      }
      return outOptions;
    }
  }, {
    key: '_setEmitterBounds',
    value: function _setEmitterBounds() {
      var delay = this.options.delay[2];
      delay += this.windowHeight * this.options.delay[0];
      delay += this.elHeight * this.options.delay[1];
      this._emitterMin = this.elTop - delay;

      var duration = this.options.duration[2];
      duration += this.windowHeight * this.options.duration[0];
      duration += this.elHeight * this.options.duration[1];
      this._emitterMax = this._emitterMin + duration;

      if (this.scrollMotionEmitter) {
        this.scrollMotionEmitter.min = this._emitterMin;
        this.scrollMotionEmitter.max = this._emitterMax;
      }
    }
  }, {
    key: '_memoizeMetrics',
    value: function _memoizeMetrics() {
      this.windowHeight = _viewportEmitter2.default.clientHeight();
      this.elHeight = (0, _domMetrics.getDimensions)(this.el).height;
      this.elTop = (0, _domMetrics.getPagePosition)(this.el).top;
    }
  }, {
    key: '_setupClipPath',
    value: function _setupClipPath() {
      if (!this.hasClipPath) {
        return;
      }
      if (!canUseClipPath) {
        this.clipElements = [null, null, null, null];
        for (var i = 0, l = 4; i < l; i++) {
          // Iterate over each side
          for (var point in this.options.clipPath) {
            // Iterate over each keyframe
            var keyframe = this.options.clipPath[point];
            if (keyframe[i] > 0) {
              var ele = this.clipElements[i] = document.createElement('div');
              ele.classList.add('cmt-clip-' + i);
              ele.style.backgroundColor = this.options.clipPathColor;
              this.el.appendChild(ele);
              break; // Break out of keyframe loop
            }
          }
        }
      }
    }
  }, {
    key: '_initScrollMotionEmitter',
    value: function _initScrollMotionEmitter() {
      if (this.options.scrollMotionEmitter) {
        this.scrollMotionEmitter = this.options.scrollMotionEmitter;
      } else if (this.options.elementScroll) {
        this.scrollMotionEmitter = new _scrollMotionEmitter.ElementScrollMotionEmitter(this.el, {
          smooth: this.options.smooth,
          overrideScroll: this.options.overrideScroll,
          overrideResize: this.options.overrideResize,
          offsetTop: this.options.offsetTop,
          offsetBottom: this.options.offsetBottom,
          friction: this.options.friction
        });
      } else {
        this.scrollMotionEmitter = new _scrollMotionEmitter.ScrollMotionEmitter({
          smooth: this.options.smooth,
          overrideScroll: this.options.overrideScroll,
          min: this._emitterMin,
          max: this._emitterMax,
          friction: this.options.friction
        });
      }
      if (!this.scrollMotionEmitter.isRunning()) {
        this.scrollMotionEmitter.start();
      }
    }
  }, {
    key: '_setupEvents',
    value: function _setupEvents() {
      this.scrollMotionEmitter.on('draw', this._update);
    }
  }, {
    key: '_teardownEvents',
    value: function _teardownEvents() {
      this.scrollMotionEmitter.off('draw', this._update);
    }
  }, {
    key: '_getKeyframeData',
    value: function _getKeyframeData(keyframes) {
      var keys = Object.keys(keyframes);
      if (keys.length === 1) {
        return [this._progress, keyframes[keys[0]], keyframes[keys[0]]];
      }
      var startPoint = null;
      var endPoint = null;
      for (var point in keyframes) {
        var f = parseFloat(point);
        if ((startPoint === null || f > startPoint) && f <= this._progress) {
          startPoint = point;
        }
        if ((endPoint === null || f < endPoint) && f >= this._progress) {
          endPoint = point;
        }
      }
      // If start keyframe wasn't found, set it to the first keyframe
      if (startPoint === null) {
        startPoint = keys[0];
      }
      // If end keyframe wasn't found, set it to the last keyframe
      if (endPoint === null) {
        endPoint = keys[keys.length - 1];
      }

      var keyframeDuration = endPoint - startPoint || 1;
      var keyframeProgress = (this._progress - startPoint) / keyframeDuration;
      return [keyframeProgress, keyframes[startPoint], keyframes[endPoint]];
    }
  }, {
    key: '_setElementTransform',
    value: function _setElementTransform() {
      if (!this.hasTransform) {
        return;
      }

      // Scale

      var _getKeyframeData2 = this._getKeyframeData(this.options.scale),
          _getKeyframeData3 = _slicedToArray(_getKeyframeData2, 3),
          scaleProgress = _getKeyframeData3[0],
          scaleStart = _getKeyframeData3[1],
          scaleEnd = _getKeyframeData3[2];

      this.transforms.scaleX = (0, _mathUtils.lerp)(scaleProgress, scaleStart[0], scaleEnd[0]);
      this.transforms.scaleY = (0, _mathUtils.lerp)(scaleProgress, scaleStart[1], scaleEnd[1]);
      var scale = this.transforms.scaleX === 1 && this.transforms.scaleY === 1 ? '' : ' scale(' + this.transforms.scaleX + ',' + this.transforms.scaleY + ')';

      // Translate

      var _getKeyframeData4 = this._getKeyframeData(this.options.translate),
          _getKeyframeData5 = _slicedToArray(_getKeyframeData4, 3),
          translateProgress = _getKeyframeData5[0],
          translateStart = _getKeyframeData5[1],
          translateEnd = _getKeyframeData5[2];

      this.transforms.translateX = (0, _mathUtils.lerp)(translateProgress, translateStart[0], translateEnd[0]);
      this.transforms.translateY = (0, _mathUtils.lerp)(translateProgress, translateStart[1], translateEnd[1]);
      var translate = ' translate3d(' + this.transforms.translateX + 'px,' + this.transforms.translateY + 'px,0)';

      // Rotate
      this.transforms.rotate = _mathUtils.lerp.apply(undefined, _toConsumableArray(this._getKeyframeData(this.options.rotate)));
      var rotation = this.transforms.rotate === 0 ? '' : ' rotate(' + this.transforms.rotate + 'deg)';

      // Apply
      this.el.style[_browserPrefixed.transform] = scale + translate + rotation;
    }
  }, {
    key: '_setElementClipPath',
    value: function _setElementClipPath() {
      if (!this.hasClipPath) {
        return;
      }

      var _getKeyframeData6 = this._getKeyframeData(this.options.clipPath),
          _getKeyframeData7 = _slicedToArray(_getKeyframeData6, 3),
          progress = _getKeyframeData7[0],
          start = _getKeyframeData7[1],
          end = _getKeyframeData7[2];

      if (canUseClipPath) {
        var vals = [];
        for (var i = 0, l = 4; i < l; i++) {
          vals[i] = (0, _mathUtils.lerp)(progress, start[i], end[i]);
        }
        this.el.style.clipPath = 'inset(' + vals[0] + 'px ' + vals[1] + 'px ' + vals[2] + 'px ' + vals[3] + 'px)';
      } else {
        for (var _i = 0, _l = 4; _i < _l; _i++) {
          var clipElement = this.clipElements[_i];
          if (clipElement) {
            var attr = 'height';
            if (_i % 2) {
              attr = 'width';
            }
            clipElement.style[attr] = (0, _mathUtils.lerp)(progress, start[_i], end[_i]) + 'px';
          }
        }
      }
    }
  }, {
    key: '_setElementOpacity',
    value: function _setElementOpacity() {
      if (!this.hasOpacity) {
        return;
      }
      this.opacity = _mathUtils.lerp.apply(undefined, _toConsumableArray(this._getKeyframeData(this.options.fade)));
      this.el.style.opacity = this.opacity;
    }
  }, {
    key: '_setStatus',
    value: function _setStatus() {
      if (this._progress > 0 && this._progress < 1 && !this._isAnimating) {
        this._isAnimating = true;
        this.el.classList.remove('has-animated');
        this.el.classList.remove('has-not-animated');
        this.el.classList.add('is-animating');
      } else {
        if (this._progress >= 1 && this._isAnimating) {
          this._isAnimating = false;
          this.el.classList.remove('is-animating');
          this.el.classList.remove('has-not-animated');
          this.el.classList.add('has-animated');
        } else {
          if (this._progress <= 0 && this._isAnimating) {
            this._isAnimating = false;
            this.el.classList.remove('is-animating');
            this.el.classList.remove('has-animated');
            this.el.classList.add('has-not-animated');
          }
        }
      }
    }
  }, {
    key: '_update',
    value: function _update(a) {
      if (isNaN(a.progress)) {
        return;
      }
      this._progress = a.progress;
      this._setElementTransform();
      this._setElementClipPath();
      this._setElementOpacity();
    }
  }]);

  return ScrollAnimation;
}();

exports.default = ScrollAnimation;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Entry point for the main script
__webpack_require__.p = CMTConfig.path + '/js/'; // eslint-disable-line
window.HELP_IMPROVE_VIDEOJS = false;
window.VIDEOJS_NO_BASE_THEME = true;
window.VIDEOJS_NO_DYNAMIC_STYLE = true;

__webpack_require__(186);

__webpack_require__(191);

__webpack_require__(194);

__webpack_require__(195);

__webpack_require__(189);

__webpack_require__(192);

__webpack_require__(190);

__webpack_require__(193);

__webpack_require__(187);

__webpack_require__(188);

__webpack_require__(120);

__webpack_require__(177);

__webpack_require__(196);

__webpack_require__(197);

__webpack_require__(159);

__webpack_require__(160);

__webpack_require__(161);

__webpack_require__(162);

__webpack_require__(165);

__webpack_require__(163);

__webpack_require__(164);

__webpack_require__(166);

__webpack_require__(167);

__webpack_require__(168);

__webpack_require__(169);

__webpack_require__(171);

__webpack_require__(170);

__webpack_require__(158);

__webpack_require__(185);

__webpack_require__(146);

__webpack_require__(156);

__webpack_require__(155);

__webpack_require__(151);

__webpack_require__(152);

__webpack_require__(150);

__webpack_require__(147);

__webpack_require__(149);

__webpack_require__(154);

__webpack_require__(148);

__webpack_require__(145);

__webpack_require__(153);

__webpack_require__(157);

__webpack_require__(119);

__webpack_require__(182);

__webpack_require__(180);

__webpack_require__(178);

__webpack_require__(183);

__webpack_require__(184);

__webpack_require__(179);

__webpack_require__(181);

__webpack_require__(172);

__webpack_require__(173);

__webpack_require__(174);

__webpack_require__(176);

__webpack_require__(175);

__webpack_require__(117);

__webpack_require__(118);

__webpack_require__(113);

__webpack_require__(116);

__webpack_require__(115);

__webpack_require__(114);

__webpack_require__(54);

__webpack_require__(139);

__webpack_require__(140);

__webpack_require__(142);

__webpack_require__(141);

__webpack_require__(138);

__webpack_require__(144);

__webpack_require__(143);

__webpack_require__(121);

__webpack_require__(122);

__webpack_require__(123);

__webpack_require__(124);

__webpack_require__(125);

__webpack_require__(126);

__webpack_require__(127);

__webpack_require__(128);

__webpack_require__(129);

__webpack_require__(130);

__webpack_require__(132);

__webpack_require__(131);

__webpack_require__(133);

__webpack_require__(134);

__webpack_require__(135);

__webpack_require__(136);

__webpack_require__(137);

__webpack_require__(198);

__webpack_require__(201);

__webpack_require__(199);

__webpack_require__(200);

__webpack_require__(203);

__webpack_require__(202);

__webpack_require__(206);

__webpack_require__(205);

__webpack_require__(204);

__webpack_require__(210);

__webpack_require__(109);
__webpack_require__(110);
// Instantiate framework
__webpack_require__(76);
// Run regular scripts
__webpack_require__(108);
__webpack_require__(111);
__webpack_require__(112);
// Run page builder scripts
__webpack_require__(107);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.softScrollHash = softScrollHash;
exports.softScrollHashes = softScrollHashes;

var _eventEmitterMicro = __webpack_require__(17);

var _eventEmitterMicro2 = _interopRequireDefault(_eventEmitterMicro);

var _scrollTo = __webpack_require__(78);

var _scrollTo2 = _interopRequireDefault(_scrollTo);

var _domMetrics = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bodyEle = document.body;

function softScrollHash(item) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

  if (item.hash.length && window.location.hostname === item.hostname && window.location.pathname.replace(/^\//, '') === item.pathname.replace(/^\//, '')) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      window.history.pushState({}, document.title, item.pathname + item.hash);
      var target = document.querySelector(item.hash);
      if (target) {
        (0, _scrollTo2.default)((0, _domMetrics.getPagePosition)(target).top, duration);
      }
    });
  }
}

function softScrollHashes(containers) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

  containers = containers || [bodyEle];
  if (containers instanceof window.NodeList) {
    containers = Array.from(containers);
  } else if (!Array.isArray(containers)) {
    containers = [containers];
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = containers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var container = _step.value;

      var items = Array.from(container.querySelectorAll('a'));
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          softScrollHash(item, duration);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

var SideMenu = exports.SideMenu = function (_EventEmitterMicro) {
  _inherits(SideMenu, _EventEmitterMicro);

  function SideMenu(element, overlay) {
    var toggleClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'side-panel-toggled';

    _classCallCheck(this, SideMenu);

    var _this = _possibleConstructorReturn(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).call(this));

    _this.element = element;
    _this.overlay = overlay;
    _this.toggleClass = toggleClass;
    _this.open = false;
    _this.togglers = [];
    _this.toggle = _this.toggle.bind(_this);
    _this.checkMenuLink = _this.checkMenuLink.bind(_this);

    var links = element.getElementsByTagName('a');
    for (var i = 0, len = links.length; i < len; i++) {
      links[i].addEventListener('click', _this.checkMenuLink);
    }
    return _this;
  }

  _createClass(SideMenu, [{
    key: 'checkMenuLink',
    value: function checkMenuLink(event) {
      var a = event.currentTarget;
      /* Toggle submenus
      const item = a.parentElement
      if (item.classList.contains('menu-item-has-children')) {
        item.classList.toggle('menu-item-open')
        event.preventDefault()
        return
      }
      */
      var location = window.location;
      if (a.hash.length && location.hostname === a.hostname && location.pathname.replace(/^\//, '') === a.pathname.replace(/^\//, '')) {
        this.toggle();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.open) {
        bodyEle.classList.remove(this.toggleClass);
        if (this.overlay) {
          this.overlay.removeEventListener('click', this.toggle);
        }
      } else {
        bodyEle.classList.add(this.toggleClass);
        if (this.overlay) {
          this.overlay.addEventListener('click', this.toggle);
        }
      }
      this.open = !this.open;
      var expanded = this.open ? 'true' : 'false';
      this.element.setAttribute('aria-expanded', expanded);
      for (var i = 0; i < this.togglers.length; i++) {
        this.togglers[i].setAttribute('aria-expanded', expanded);
      }
      this.trigger('toggle', this.open);
      if (this.open) {
        this.trigger('open');
      } else {
        this.trigger('close');
      }
    }
  }, {
    key: 'addToggler',
    value: function addToggler(element) {
      var _this2 = this;

      element.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.toggle();
      });
      element.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      this.togglers.push(element);
    }
  }]);

  return SideMenu;
}(_eventEmitterMicro2.default);

/***/ }),
/* 234 */,
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(1);
var isArray = __webpack_require__(87);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(235);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(22);
var isObject = __webpack_require__(1);
var invoke = __webpack_require__(86);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(26);
var gOPS = __webpack_require__(49);
var pIE = __webpack_require__(42);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(1);
var setPrototypeOf = __webpack_require__(69).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(40);
var descriptor = __webpack_require__(27);
var setToStringTag = __webpack_require__(35);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(10)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(67);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(73).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(31)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(7);
var anObject = __webpack_require__(2);
var getKeys = __webpack_require__(26);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var isObject = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(94);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(23);
var LIBRARY = __webpack_require__(25);
var wksExt = __webpack_require__(106);
var defineProperty = __webpack_require__(7).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(68);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return FastClick;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js